import { Component, OnInit, ViewChild, Output } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpEventType, HttpParams } from '@angular/common/http';
import { Observable, Subject, merge, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, debounce } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { catchError } from 'rxjs/operators';
import { Router, Data, ActivatedRoute } from '@angular/router';
import { DatePipe, DecimalPipe } from '@angular/common';
import { SWAlertService } from '../../services/swalert.service';
import { BusinessDayService } from '../../services/business-day.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker/public_api';
import { promise } from 'protractor';
import { isNullOrUndefined } from 'util';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/ngx-bootstrap-typeahead';
import Swal from 'sweetalert2';
import * as XLSX from "xlsx";
import { async } from 'rxjs/internal/scheduler/async';
declare var Uploadfiles, Clearuploadfile, SetData, _Path, Extension: any, Accept: any
declare var ArrFile: any[];
@Component({
  selector: 'app-billingtocash',
  templateUrl: './billingtocash.component.html',
  styleUrls: ['./billingtocash.component.css'],
  providers: [DatePipe, TSFuntionService, DecimalPipe]
})
export class BillingToCashComponent implements OnInit {
  VendorCodemaxLength: any = 40;
  isUseIo: boolean = false;
  isUseGL: boolean = false;
  EditInvoiceCode: any;
  EditInvoiceDate: any;
  ResultPermission: boolean;
  //NoResults
  TypeNoResult: any;
  CopyNoResult: any;
  GlNoResult: any[] = [];
  CostCenterNoResult: any[] = [];
  IONoResult: any[] = [];
  ProfitCenterNoResult: any[] = [];
  Approve1NoResult: any;
  Approve2NoResult: any;
  isCountryNoResult: any = false;
  sAmphorNoResult: any = false;
  sTumbonNoResult: any = false;
  sSubDistrictNoResult: any = false;
  //
  nReqUrgentDay: any = 0;
  IsNotFill_IO = false;
  IsNotFill_GL = false;
  isDraft: boolean = false;
  isNew: boolean = true;
  isSubmit: boolean = false;
  sReqID: any;
  sReqCode: any;
  haveRequestCode: boolean = false;
  haveComments: boolean = true;
  sComment: string = "";
  sCommentSSC: string = "";
  ArrTransactionHistory: Array<any> = [];
  IsReqUrgent: boolean = false;
  nEditindex: any;
  isEdit: boolean;
  isPrint: boolean = false;
  isEditFromhome: boolean = false;
  isThai: boolean;
  bg_color: string = '';
  IsVendorOneTime: boolean = false;
  myFiles: string[] = [];
  sMsg: string = '';
  name: string;
  vendorcode: string;
  sGL: string;
  hBranch: boolean;
  hVatAmount: boolean;
  nComcode: any;
  nCostCenterCode: any;
  sCostcen: any;
  sPostingDate: any;
  ArrInvoice: Array<any> = [];
  ArrInvoicelength: any;
  ArrMaster: Array<any> = [];
  DataEmployee: any;
  DataRequest: any;
  DataVendor: any = [];
  DataVendorAll: any = [];
  DataGL: any;
  DataCostCenter: any;
  DataIO: any;
  DataProfitCenter: any;
  DataApprover: any;
  DataBusinessArea: any;
  ArrEmployee: any[] = [];
  ArrRequest: any[] = [];
  ArrVendor: any[] = [];
  ArrVendorName: any[] = [];
  _ArrCountry: any;
  _ArrProvince: any;
  _ArrAmphur: any;
  _ArrTumbon: any;
  ArrIO: any[] = [];
  sArrGL: any[] = [];
  ArrCostCenter: any[] = [];
  ArrProfitCenter: any[] = [];
  ArrApprover: any[] = [];
  GetApprover: any;
  clicked: boolean  = false;
  isReject: boolean = false;
  Currency: any;
  Currencys: any;
  WHT: any;
  WHTCode: any;
  VatType: any;
  TM_Config: any;
  today: number = Date.now();
  dToday = this.datepipe.transform(this.today, 'dd/MM/yyyy')
  maxDate: Date;
  maxDateinvoice: any;
  TODAY: Date;
  toDay: Date;
  Settodate: Date;
  todayy: any;
  isNewRequest: boolean = false;
  isForROS: boolean = false;
  holidays: Date[]; //ตัวแปรรับค่า holiday
  _HolidayDB = [];

  fileName = "";
  fileDetail: File;
  fileExcel: any;
  ExcelData: any;
  ExcelDataCustomer: any;
  isDisableImport = true;
  arrExcel: any[] = [];

  bsConfig: Partial<BsDatepickerConfig>; //Set congic datepicker เท่านั้น ส่วน daterangpicker จะใช้อีก confic หนึ่ง
  paytovendorForm: FormGroup;
  get _paytovendorForm() { return this.paytovendorForm.controls; }
  get ArrGL() { return this._paytovendorForm.ArrGL as FormArray; }//Dynamic
  fileType: any;
  limit: any;
  FieldOnetimeValid: any[] = [
    { _Field: "sCountryID", _Validator: Validators.required, _Value: "213" },
    { _Field: "txtCountryID", _Validator: Validators.required, _Value: "ประเทศไทย" },
    { _Field: "sProvCode", _Validator: Validators.required, _Value: "" },
    { _Field: "sProvName", _Validator: Validators.required, _Value: "" },
    { _Field: "sAmpCode", _Validator: Validators.required, _Value: "" },
    { _Field: "sAmpName", _Validator: Validators.required, _Value: "" },
    { _Field: "sTumbonCode", _Validator: Validators.required, _Value: "" },
    { _Field: "sTumbonName", _Validator: Validators.required, _Value: "" },
    { _Field: "sPostCode", _Validator: null, _Value: "" },
    { _Field: "sPhoneNumber", _Validator: null, _Value: "" },
    { _Field: "sFaxNumber", _Validator: null, _Value: "" },
    { _Field: "sVendorEmail", _Validator: Validators.email, _Value: "" },
  ];
  constructor(private http: HttpClient, private formBuilder: FormBuilder, public datepipe: DatePipe, private SW: SWAlertService, private BusinessDay: BusinessDayService, private _decimalPipe: DecimalPipe, private System: TSFuntionService, private activatedRoute: ActivatedRoute, private router: Router) { }

  async ngOnInit() {
    this.System.BlockUI();
    this._ArrAmphur = [];
    this._ArrTumbon = [];
    let ua = this.System.GetUserStorage();
    this.nComcode = ua.sCompCode;
    this.ArrMaster[0] = [];
    this.isEdit = false;
    this.maxDate = new Date();
    this.maxDateinvoice = new Date();
    this.maxDate.setDate(this.maxDate.getDate() + 1)
    this.TODAY = new Date();
    this.toDay = new Date();
    this.hBranch = true;
    this.SetForm();
    await this.http.get<any>("api/Autocomplete/TM_Holiday/*").toPromise().then(res => {
      if (res) {
        this._HolidayDB = res.filter(f => f.IsDelete == false && f.cActive == "Y");
      }
      this.holidays = this._HolidayDB.map(({ dDate }) => new Date(dDate))
    })
    //confic datepicker
    this.bsConfig = Object.assign({}, {
      containerClass: 'theme-dark-blue' //set theme
      , dateInputFormat: 'DD/MM/YYYY' //set Format
      , showWeekNumbers: false
      , datesDisabled: this.holidays //set holidays (type Date only)
      , daysDisabled: [0, 6]
    });

    this.today = this.BusinessDay.SetToday(this.holidays).getTime();
    this.dToday = this.datepipe.transform(this.today, 'dd/MM/yyyy');
    // this.TODAY = this.BusinessDay.SetNextDate(this.maxDate, this.holidays);
    this.Settodate = this.BusinessDay.SetToday(this.holidays);
    this.TODAY = this.BusinessDay.SetToday(this.holidays);
    this.TODAY.setDate(this.TODAY.getDate() + 1);
    this.TODAY = this.BusinessDay.SetNextDate(this.TODAY, this.holidays);
    this.paytovendorForm.patchValue({ dDueDate: this.TODAY })

    await this.GetAutocomplete();
    this.hVatAmount = false;
    this.paytovendorForm.controls['sBranch'].disable();
    this.paytovendorForm.controls['nWHTOther'].disable();
    this.paytovendorForm.controls['nWHTOther2'].disable();
    this.paytovendorForm.controls['sVendorName'].disable();
    this.paytovendorForm.controls['sTAXID'].disable();
    this.paytovendorForm.controls['sAddress'].disable();
    this.checkUseIo();
    this.checkUseGL();
    // let Duedate = this.paytovendorForm.value.dDueDate; //get value dDue formControlName
    this.paytovendorForm.patchValue({ dDueDate: this.TODAY });
    this.activatedRoute.queryParams.subscribe(async params => {
      let ID: string = this.System.GetQuerySTR('str');
      let ID2: string = this.System.GetQuerySTR('ros');
      this.sReqID = await this.System.Decrypt(ID);
      if (ID2 !== 'undefined') {
        this.sReqID = await this.System.Decrypt(ID2);
        this.isForROS = true;
      }
      if(this.sReqID === ''){
        this.isNewRequest = true;
      }
      this.Edit(this.sReqID);
    });
    await this.getFileType();
    await this.getFileLimit();
    var setUp = {
      sID: "dvFile",
      nFileSize: 15,
      Accepts: Accept.GetFix(this.fileType),
      Extensions: Extension.GetFix(this.fileType),
      ModeMulti: true,
      ArrFile: ArrFile,
      View: false,
      HasURL: true,
      UrlUpload: this.System.SiteName + _Path.PathUpload,
      limit: this.limit
    };
    Uploadfiles(setUp);
    Clearuploadfile();
  }

  async importFile(event) {
    let _this = this;
    let isBreak = false;
    const target: DataTransfer = <DataTransfer>event.target;
    this.fileName = target.files[0].name;
    this.fileDetail = target.files[0];
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const workbook = XLSX.read(bstr, { type: "binary" });


      if (workbook.SheetNames[1] == 'Master') {
        this.IsVendorOneTime = false;
        this.paytovendorForm.patchValue({ ntype: '70'});
      }
      else if (workbook.SheetNames[1] == 'Onetime') {
        this.IsVendorOneTime = true;
        this.paytovendorForm.patchValue({ ntype: '71'});
      }
      else {
        isBreak = true;
        this.SW.SwAlert.Error(
          this.SW.BoxMsg.Title_Error,
          this.SW.BoxMsg.Desc_Error_Excel_Template,
          undefined
        );
      }
  

      if (!isBreak) {
        this.ExcelData = XLSX.utils.sheet_to_json(
          workbook.Sheets[workbook.SheetNames[1]],
          { raw: false, rawNumbers: true }
        );
        if (this.IsVendorOneTime) {
          this.ExcelDataCustomer = XLSX.utils.sheet_to_json(
            workbook.Sheets[workbook.SheetNames[2]],
            { raw: false, rawNumbers: true }
          );
        }
      }
      
    };
    if (!isBreak) {
      reader.readAsBinaryString(this.fileDetail);
      event.target.value = ''
      var formData = new FormData();
      formData.append('file', this.fileDetail);
      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'api/_Paytovendor/UploadExcel'); // Replace with your controller and action method names
      xhr.onload = function() {
       
      };
      xhr.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
            var response = xhr.response;
            const responseJson = JSON.parse(response);
            if (response) {
              _this.fileExcel = {
                nID: 1,
                sPath: responseJson.SaveToPath,
                sSystemFileName: responseJson.SaveToFileName,
                sFileName: responseJson.FileName,
                IsDelete: false,
                IsNew: true,
                sSize: _this.fileDetail.size,
              }
            }
        };
      }
      xhr.send(formData);
    }
  }
  checkHaveFileUpload() {
    this.isDisableImport = this.ExcelData === undefined;
    return "";
  }

  async readFile() {
    this.System.BlockUI();
    this.ArrGL.clear();
    this.ArrInvoice = [];
    this.arrExcel = [];
    let _this = this;
    if (this.ExcelData.length > 0) {
      const result = [];
      const resultExcel = [];
      let checkRequireField = false;
      let errorRequireField = '';
      if(this.paytovendorForm.value.ntype === '71'){
        this.IsVendorOneTime = true;
      }
     
      for (let x = 0; x < this.ExcelData.length; x++) {
        let itemExcel = {
          sNo: null,
          sVendorCode: null,
          sVendorName: null,
          sInvoiceNo: null,
          dInvoiceDate: null,
          dPostingDate: null,
          dDueDate: null,
          sDueDate: null,
          sVatType: null,
          sGL: null,
          sPTC: null,
          nExcludeVAT: null,
          nWHTBase: null,
          sInvoiceDesc: null,
          sWHTType: null,
          sWHTCode: null,
          sDocHeader: null,
        };

        let item = {
          sInvoiceNo: null,
          sVatType: null,
          nLine: 1,
          sGL: null,
          sCostCenter: null,
          sIO: null,
          sProfitCenter: null,
          sAmount: null,
          sText: null,
          cVenderMaster: 'M',
          sVendorCode: null,
          sVendorName: null,
          sTAXID: null,
          sVendorBranch: null,
          sVendorAddress: null,
          dInvoiceDate: null,
          sCurrency: 'THB',
          nExcludeVAT: 0,
          nVAT: 0,
          nIncludeVAT: 0,
          nWHTID: 0,
          nWHTID2: 0,
          sWHTType: null,
          sWHTCode: null,
          nWHTRate: 0,
          nWHTRate2: 0,
          nWHTVal: 0,
          _nWHTVal: 0,
          nWHTVal2: 0,
          _nWHTVal2: 0,
          nWHTBase: 0,
          nWHTBase2: 0,
          nOfficeType: 1,
          nInvoiceType: null,
          IsVendorOneTime: this.IsVendorOneTime,
          IsDelete: false,
          sDocHeader: null
        };

        itemExcel.sNo = (x + 1).toString();;
        if (this.ExcelData[x]["Customer Code"]){
          if (this.ExcelData[x]["Customer Code"].length > 20) {
            checkRequireField = true;
            errorRequireField = 'Customer Code must not exceed 20 characters';
            break;
          }
          else {
            itemExcel.sVendorCode = this.ExcelData[x]["Customer Code"];
            this.paytovendorForm.patchValue({ nVendorCode: this.ExcelData[x]["Customer Code"] });
          }
        }
        else if (!this.IsVendorOneTime) {
          checkRequireField = true;
          break;
        }
        if (this.ExcelData[x]["Customer"]) itemExcel.sVendorName = this.ExcelData[x]["Customer"];
        if (this.ExcelData[x]["Invoice Date"]) {
          itemExcel.dInvoiceDate = this.dateFormat(this.ExcelData[x]["Invoice Date"]);
        }
        else {
          checkRequireField = true;
          break;
        }
        if (this.ExcelData[x]["Posting Date"]) {
          itemExcel.dPostingDate = this.dateFormat(this.ExcelData[x]["Posting Date"]);
          _this.sPostingDate = this.ExcelData[x]["Posting Date"]
        }
        else {
          checkRequireField = true;
          break;
        }
        if (this.ExcelData[x]["Due Date"]){
          itemExcel.dDueDate = this.dateFormat(this.ExcelData[x]["Due Date"]);
          itemExcel.sDueDate = this.dateFormat(this.ExcelData[x]["Due Date"]);
        }
        else {
          checkRequireField = true;
          break;
        }
        if (this.ExcelData[x]["Vat Code"]){
          if (this.ExcelData[x]["Vat Code"].length > 2) {
            checkRequireField = true;
            errorRequireField = 'Vat Code must not exceed 2 characters';

            break;
          }
          else {
            itemExcel.sVatType = this.ExcelData[x]["Vat Code"];
          }
        }
        else {
          checkRequireField = true;
          break;
        }
        if (this.ExcelData[x]["GL รายได้"]){
          if (this.ExcelData[x]["GL รายได้"].length > 10) {
            checkRequireField = true;
            errorRequireField = 'GL รายได้ must not exceed 10 characters';
            break;
          }
          else {
            itemExcel.sGL = this.ExcelData[x]["GL รายได้"];
          }
        }
        else {
          checkRequireField = true;
          break;
        }
        if (this.ExcelData[x]["Profit Center"]){
          if (this.ExcelData[x]["Profit Center"].length > 20) {
            checkRequireField = true;
            errorRequireField = 'Profit Center must not exceed 20 characters';
            break;
          }
          else {
            itemExcel.sPTC = this.ExcelData[x]["Profit Center"];
          }
        }
        else {
          checkRequireField = true;
          break;
        }
        if (this.ExcelData[x]["Amount (รวม vat)"]){
          itemExcel.nExcludeVAT = this.ExcelData[x]["Amount (รวม vat)"];
        }
        else {
          checkRequireField = true;
          break;
        }
        if (this.ExcelData[x]["WHT Base"]){
          itemExcel.nWHTBase = this.ExcelData[x]["WHT Base"];
        }
        else {
          checkRequireField = true;
          break;
        }

        if (this.ExcelData[x]["Text (50 CHAR)"]){
          itemExcel.sInvoiceDesc = this.ExcelData[x]["Text (50 CHAR)"];
        }
        else {
          checkRequireField = true;
          break;
        }
        if (this.ExcelData[x]["WHT Type1"]) {
          if (this.ExcelData[x]["WHT Type1"].length > 2) {
            checkRequireField = true;
            errorRequireField = 'WHT Type1 must not exceed 2 characters';

            break;
          }
          else {
            itemExcel.sWHTType = this.ExcelData[x]["WHT Type1"];
          }
        }
        if (this.ExcelData[x]["WHT Code1"]) {
          if (this.ExcelData[x]["WHT Code1"].length > 2) {
            checkRequireField = true;
            errorRequireField = 'WHT Code1 must not exceed 2 characters';
            break;
          }
          else {
            itemExcel.sWHTCode = this.ExcelData[x]["WHT Code1"];
          }
        }
        if (this.ExcelData[x]["Header"]) {
          if (this.ExcelData[x]["Header"].length > 25) {
            checkRequireField = true;
            errorRequireField = 'Header must not exceed 25 characters';
            break;
          }
          else {
            itemExcel.sDocHeader = this.ExcelData[x]["Header"];
          }
        }
      
        if (this.IsVendorOneTime) {
          if (this.ExcelData[x]["CV No. (30 CHAR)"]) {

            if (this.ExcelData[x]["CV No. (30 CHAR)"].length > 30) {
              checkRequireField = true;
              errorRequireField = 'CV No. (30 CHAR)';
              break;
            }
            else {
              itemExcel.sInvoiceNo = this.ExcelData[x]["CV No. (30 CHAR)"];
            }
          } else {
            checkRequireField = true;
            break;
          }
          if (this.ExcelData[x]["Customer Nickname"]) {
            itemExcel.sVendorName = this.ExcelData[x]["Customer Nickname"];
          } else {
            checkRequireField = true;
            break;
          }
        }
        if (!itemExcel.sInvoiceNo) itemExcel.sInvoiceNo = `Blank_${this.datepipe.transform(Date.now(), 'yyyyMMddHHmm')}${('0' + x).slice(-2)}`;

        item.sInvoiceNo = itemExcel.sInvoiceNo;
        item.sVendorName = itemExcel.sVendorName;
        item.sVendorCode = itemExcel.sVendorCode;
        item.sVatType =  itemExcel.sVatType;
        item.sGL =  itemExcel.sGL;
        item.sProfitCenter =  itemExcel.sPTC;
        item.sAmount =  itemExcel.nExcludeVAT * 1;
        item.nWHTBase =  itemExcel.nWHTBase * 1;
        item.nIncludeVAT = item.sAmount;
        item.sText =  itemExcel.sInvoiceDesc;
        item.dInvoiceDate = this.datepipe.transform(itemExcel.dInvoiceDate, 'dd/MM/yyyy')
        item.sWHTType = itemExcel.sWHTType;
        item.sWHTCode = itemExcel.sWHTCode;
        item.sDocHeader = itemExcel.sDocHeader;

        if (this.IsVendorOneTime) {
          if (this.ExcelDataCustomer.filter(s => s['Customer Nickname (18 CHAR)'] == item.sVendorName).length > 0) {
            let dataVendor = this.ExcelDataCustomer.filter(s => s['Customer Nickname (18 CHAR)'] == item.sVendorName)[0];
            item.sTAXID = dataVendor['Tax No.'];
            item.sVendorAddress = `${dataVendor['House number and street (35 CHAR)']} ${dataVendor['City (35 CHAR)']} ${dataVendor['Address in Name 4 (35 CHAR)']} ${dataVendor['Postal Code (10 CHAR)']} `;
          }
        }
        else {
          if (this.DataVendor.filter(s => s.CUSTOMER_CODE == item.sVendorCode).length > 0) {
            let dataVendor = this.DataVendor.filter(s => s.CUSTOMER_CODE == item.sVendorCode)[0];
            itemExcel.sVendorName = dataVendor.VENDORNAME;
            item.sVendorName = itemExcel.sVendorName;
            item.sTAXID = dataVendor.TAX_ID;
            item.sVendorAddress = dataVendor.ADDRESS;
          }
        }

        if (this.VatType.filter(s => s.TAX_CODE == item.sVatType).length > 0) {
          let dataVat = this.VatType.filter(s => s.TAX_CODE == item.sVatType)[0]
            item.nExcludeVAT = Math.round(item.sAmount / (1 + dataVat.nVAT) * 100) / 100;
            item.nVAT = Math.round(item.nExcludeVAT * dataVat.nVAT * 100) / 100;
            item.sAmount =  item.nExcludeVAT;
        }

        if (this.WHTCode.filter(s => s.WHTCode == item.sWHTCode).length > 0) {
          let dataWHT = this.WHTCode.filter(s => s.WHTCode == item.sWHTCode)[0]
            item.nWHTVal = Math.round(item.nWHTBase * dataWHT.WHTRate) / 100;
            item._nWHTVal = item.nWHTVal;
        }
        itemExcel.nExcludeVAT = item.sAmount;
       
        resultExcel.push(itemExcel);
        result.push(item);
      }
      if (checkRequireField) {
        _this.SW.SwAlert.Error(
          _this.SW.BoxMsg.Title_Error,
          errorRequireField != ''? errorRequireField : _this.SW.BoxMsg.Desc_Specify_Require,
          undefined
        );
      } else {
        result.forEach((item) => {
          _this.ArrInvoice.push(item);
        });
        resultExcel.forEach((item) => {
          _this.arrExcel.push(item);
        });
      }
      this.CalGrand();
    }
    this.System.UnBlockUI();
  }

  dateFormat(dateData) {
    const date = new Date((dateData - 25569) * 86400 * 1000);
    let result = null;
    if (isNaN(date.getDate())) {
      result = new Date(dateData);
    } else {
      result =
        date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();
    }
    return result;
  }

  onDownloadTemplate() {
    let sendData = JSON.stringify({});
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });
    let sReqType = 'B2CI'
    if (this.paytovendorForm.value.ntype === '71') {
      sReqType += '_Onetime'
    }
    
    this.http
      .post(
        this.System.SiteName + "api/_Paytovendor/DownloadTemplate?sReqID=" + sReqType,
        sendData,
        { headers, responseType: "arraybuffer" }
      )
      .subscribe((res) => {
        const blob = new Blob([res], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        this.save(blob, sReqType + "_Template.xlsx");
      });
  }

  save(blob, fileName) {
    if (window.navigator.msSaveOrOpenBlob) {
      // For IE:
      navigator.msSaveBlob(blob, fileName);
    } else {
      // For other browsers:
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(link.href);
    }
  }


  async Reject() {
    let _this = this;
    let sComment = _this.paytovendorForm.get('sComment').value;
    if (sComment === null || sComment === "") {
      _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.Desc_Specify_Comment, undefined)
    }
    else{
      let DataSave = {
        TRequest: {
          sRequestID: _this.paytovendorForm.get('sRequestID').value,
          sComment: sComment,
        },
      }
      let Data = JSON.stringify(DataSave)
      let save = function () {
        _this.System.BlockUI();
        const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });
        _this.http.post(_this.System.SiteName + "api/ROService/Reject", Data, { headers, responseType: 'text' }).subscribe(s => {
          if (s == "Success") {
            ArrFile = [];
            _this.System.UnBlockUI();
            _this.SW.SwAlert.Success(_this.SW.BoxMsg.Title_Success, _this.SW.BoxMsg.Desc_SaveComplete, function () { _this.router.navigate(["ro-service"]) });
          } else {
            _this.System.UnBlockUI();
          }
        });
      }
      _this.SW.SwAlert.Confirm(_this.SW.BoxMsg.Title_Confirm, _this.SW.BoxMsg.Desc_Confirm_Submit, save, function () { });
    }
  }
  checkFile() {
    if (ArrFile.filter(f => f.IsDelete === false).length > 0) {
      const chkFile =  document.getElementById('dv_dvFile');
      chkFile.style.border = '1px solid #dde4f6';
    }
    return '';
  }
  async getFileType() {
    await this.http.get(this.System.SiteName + 'api/FileConfig/FileType').toPromise().then((data: Response) => {
      const result = [];
      const item = Object.values(data);
      for (let x = 0; x < item.length; x++ ) {
        if (data[x]['sValue'] === 'Y') {
          result.push(data[x]['sValueText']);
        }
      }
      this.fileType = result;
    });
  }
  async getFileLimit() {
    await this.http.get(this.System.SiteName + 'api/FileConfig/FileLimit').toPromise().then((data: Response) => {
      const result = [];
      const item = Object.values(data);
      for (let x = 0; x < item.length; x++ ) {
        result.push(data[x]['sValue']);
      }
      this.limit = result;
    });
  }
  setVat() {
    let _this = this;
    let vatType = this.paytovendorForm.value.ddVatType;
    if (vatType != "-1") {
      let datavat = { nVAT: '', TAX_CODE: '' };
      if (this.VatType.filter(s => s.TAX_CODE == vatType).length > 0) {
        datavat = this.VatType.filter(s => s.TAX_CODE == vatType)[0]
        this.paytovendorForm.patchValue({ nVat: datavat.nVAT });
        this.hVatAmount = datavat.TAX_CODE == "VZ" ? true : false;
      }

      if (this.hVatAmount == true) {
        _this.paytovendorForm.controls.nVatAmount.clearValidators();
        _this.paytovendorForm.controls.nVatAmount.markAsUntouched({ onlySelf: true });
        _this.paytovendorForm.controls.nVatAmount.setValidators([]);
        _this.paytovendorForm.controls.nVatAmount.setErrors(null);
        _this.paytovendorForm.controls.nVatAmount.updateValueAndValidity();
        _this.paytovendorForm.controls.nVatAmount.disable();
        _this.calVat();
        _this.paytovendorForm.patchValue({
          nVatAmount: null,
        });
      } else if (this.hVatAmount == false) {
        _this.paytovendorForm.controls["nVatAmount"].clearValidators();
        _this.paytovendorForm.controls["nVatAmount"].setValidators([Validators.required]);
        _this.paytovendorForm.controls["nVatAmount"].updateValueAndValidity();
        _this.paytovendorForm.controls.nVatAmount.enable();
        _this.calVat();
      }
    }
  }
  Editsetvat() {
    let _this = this;
    let vatType = this.paytovendorForm.value.ddVatType;
    if (vatType != "-1") {
      let datavat = { nVAT: '', TAX_CODE: '' };
      if (this.VatType.filter(s => s.TAX_CODE == vatType).length > 0) {
        datavat = this.VatType.filter(s => s.TAX_CODE == vatType)[0]
        this.paytovendorForm.patchValue({ nVat: datavat.nVAT });
        this.hVatAmount = datavat.TAX_CODE == "VZ" ? true : false;
      }

      if (this.hVatAmount == true) {
        _this.paytovendorForm.controls.nVatAmount.clearValidators();
        _this.paytovendorForm.controls.nVatAmount.markAsUntouched({ onlySelf: true });
        _this.paytovendorForm.controls.nVatAmount.setValidators([]);
        _this.paytovendorForm.controls.nVatAmount.setErrors(null);
        _this.paytovendorForm.controls.nVatAmount.updateValueAndValidity();
        _this.paytovendorForm.controls.nVatAmount.disable();
        //_this.calVat();
        _this.paytovendorForm.patchValue({
          nVatAmount: null,
        });
      } else if (this.hVatAmount == false) {
        _this.paytovendorForm.controls["nVatAmount"].clearValidators();
        _this.paytovendorForm.controls["nVatAmount"].setValidators([Validators.required]);
        _this.paytovendorForm.controls["nVatAmount"].updateValueAndValidity();
        _this.paytovendorForm.controls.nVatAmount.enable();
      }
    }
  }
  handler(select): void {
    if (select == 1) {
      let Duedate = this.paytovendorForm.value.dDueDate; //get value dDue formControlName
      this.paytovendorForm.patchValue({ dDueDate: Duedate });
    }
    if (select == 2) {
      let Invoicedate = this.paytovendorForm.value.dInvoiceDate;
      this.paytovendorForm.patchValue({ dInvoiceDate: Invoicedate });
    }
  }
  //#region "GetAutocomplete"
  async GetAutocomplete() {
    this.http.get(this.System.SiteName + "api/Autocomplete/TUserpermission/*/sCompCode/" + this.nComcode + "/nRole/5").subscribe((data: Response) => {
      this.DataEmployee = data;
      this.ArrEmployee = this.DataEmployee.map(data => data.sName + " " + data.sSurName)
    })

    //AutocompleteMT_Vendor
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sComCode", this.nComcode + "")
    };
    let _this = this;
    this.http.get<any>(this.System.SiteName + "api/_System/GetCustomer", httpOptions).toPromise().then(data => {
      this.DataVendorAll = data;
      data.filter(function (item) {
        _this.DataVendor.push(item);
      });
      this.ArrVendor = this.DataVendor.filter(f => f.IsOnetimeVendor === false).map(re => ({ Customer: re.CUSTOMER_CODE + " - " + re.VENDORNAME, CUSTOMER_CODE: re.CUSTOMER_CODE, sAddress: re.ADDRESS, sVendorName: re.VENDORNAME, TAX_NUMBER1: re.TAX_ID, IsOnetimeVendor: re.IsOnetimeVendor }))
    })

  

    //AutocompleteTRequest
    this.ArrRequest = [];
    this.http.get(this.System.SiteName + "api/_Paytovendor/GetCopyB2C/" + this.nComcode + "").subscribe((data: Response) => {
      this.DataRequest = data;
      if (this.DataRequest != null) {
        this.ArrRequest = this.DataRequest.map(re => re.sRequestCode)
      }
    })

    const httpOptions_GL = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.nComcode)
    };
    //AutocompleteGL
    await this.http.get(this.System.SiteName + "api/_System/GetGL", httpOptions_GL).toPromise().then((data: Response) => {
      this.DataGL = data;
      this.sArrGL = this.DataGL;
    })

    const httpOptions_CostCenter = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.nComcode)
    };
    //AutocompleteCOSTCENTER
    this.http.get(this.System.SiteName + "api/_System/GetCostCenter", httpOptions_CostCenter).subscribe((data: Response) => {
      this.DataCostCenter = data;
      this.ArrCostCenter = this.DataCostCenter;
    })

    const httpOptions_IO = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.nComcode)
    };
    //AutocompleteIO
    await this.http.get(this.System.SiteName + "api/_System/GetIO2", httpOptions_IO).toPromise().then((data: Response) => {
      this.DataIO = data;
      if (this.DataIO != null) {
        this.ArrIO = this.DataIO;
        this.ArrMaster[0] = this.ArrIO;
      }
    })

    const httpOptions_ProfitCenter = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.nComcode)
    };
    //AutocompleteProfitCenter
    await this.http.get(this.System.SiteName + "api/_System/GetProfitCenter", httpOptions_ProfitCenter).toPromise().then((data: Response) => {
      if (data != null) {
        this.DataProfitCenter = data;
        this.ArrProfitCenter = this.DataProfitCenter;
      }
    })

    //AutocompleteApprover
    await this.http.get(this.System.SiteName + "api/_Paytovendor/GetApproverAll/" + this.nComcode + "").toPromise().then((data: Response) => {
      if (data) {
        this.DataApprover = data;
      } else {
        this.DataApprover = [];
      }

      this.ArrApprover[0] = [];
      this.ArrApprover[1] = [];

      //GetApprover
      this.http.get(this.System.SiteName + "api/_Paytovendor/GetApprover/" + this.nComcode + "/70").toPromise().then((data: Response) => {
        if (data) {
          this.GetApprover = data[0];
        } else {
          this.GetApprover = null;
        }
        if (this.GetApprover != null) {
          if (this.GetApprover.cActive == "Y") {
            this.ArrApprover[0] = this.DataApprover.filter(f => f.nRole == 3);
            this.ArrApprover[1] = this.DataApprover.filter(f => f.nRole == 4);
            if (this.GetApprover.IsApprover_1 == false) {
              this.paytovendorForm.controls['ddApprover1'].disable();
              this.paytovendorForm.controls['cSkipApprove1'].setValue(true);
            } else {
              this.paytovendorForm.controls['ddApprover1'].enable();
              this.paytovendorForm.controls['cSkipApprove1'].setValue(false);
              let name1 = this.DataApprover.filter(f => f.nUserID == this.GetApprover.name1ID)[0];
              let nUserId = this.DataApprover.filter(f => f.nUserID == this.GetApprover.name1ID)[0];
              this.paytovendorForm.patchValue({
                ddApprover1: isNullOrUndefined(name1) == true ? "" : name1.name1,
                sApprove1: isNullOrUndefined(nUserId) == true ? null : nUserId.nUserID,
              })
            }
            if (this.GetApprover.IsApprover_2 == false) {
              this.paytovendorForm.controls['ddApprover2'].enable();
            } else {
              this.paytovendorForm.controls['ddApprover2'].enable();

              let name1 = this.DataApprover.filter(f => f.nUserID == this.GetApprover.name2ID)[0];
              let nUserId = this.DataApprover.filter(f => f.nUserID == this.GetApprover.name2ID)[0];
              this.paytovendorForm.patchValue({
                ddApprover2: isNullOrUndefined(name1) == true ? "" : name1.name1,
                sApprove2: isNullOrUndefined(nUserId) == true ? null : nUserId.nUserID,
              })
            }
          } else if (this.GetApprover.cActive == "N") {
            this.ArrApprover[0] = this.DataApprover.filter(f => f.nRole == 3);
            this.ArrApprover[1] = this.DataApprover.filter(f => f.nRole == 4);
          }
        }
      })

    })
    //Country
    await this.http.get<any>(this.System.SiteName + "api/_System/GetContry").toPromise().then(res => {
      if (res) {
        this._ArrCountry = res;
      }
    });
    //ProvCode
    await this.http.get<any>(this.System.SiteName + "api/_System/GetProvCode").toPromise().then(res => {
      if (res) {
        this._ArrProvince = res;
      }
    });

    //DropdownCurrency
    this.http.get(this.System.SiteName + "api/Autocomplete/MT_CURRENCY/*").subscribe((data: Response) => {
      this.Currency = data;
    })

    //DropdownGetWHT
    this.http.get(this.System.SiteName + "api/_Paytovendor/GetWHT").subscribe((data: Response) => {
      this.WHT = data;
    })

    //DropdownGetWHTCode
    this.http.get(this.System.SiteName + "api/_Paytovendor/GetWHTCode").subscribe((data: Response) => {
      this.WHTCode = data;
    })

    //DropdownVatType
    this.http.get(this.System.SiteName + "api/Autocomplete/Like/MT_VATTYPE/*/sReqType/70").subscribe((data: Response) => {
      let tempData: any;
      tempData = data
      //this.VatType = tempData.filter(f => f.TAX_CODE != "D7");
      this.VatType = tempData;
    })

    //DropdownBusinessAreas
    this.http.get<any>(this.System.SiteName + "api/Autocomplete/MT_BUSINESS_AREA/*").subscribe(data => {
      if (data != null) {
        this.DataBusinessArea = data;
        this.paytovendorForm.patchValue({
          sBusinessArea: this.DataBusinessArea.filter(f => f.CompCode == this.nComcode)[0].BUSINESS_AREA,
        })

      }

    })

  }
  //#endregion
  onUserSelect(sName) {
    let lstData = this.DataEmployee.filter(user => user.sName + " " + user.sSurName == sName)[0]
    if (lstData != undefined) {
      this.nComcode = lstData.sCompCode;
      this.paytovendorForm.patchValue({
        nContactID: lstData.sEmpCode,
        sName: lstData.sName + " " + lstData.sSurName,
        sEmail: lstData.sEmail,
        sUnit: lstData.sUnit,
        sTel: lstData.sTel,
      });

    } else {

    }
  }
  async onTypeSelect(type, isOnetime, changeApprover = true) {
    let _this = this;
    let Type = this.paytovendorForm.value.ntype;
    if (type != null) {
      let stype = type.substring(0, 2);
      if (stype == "RX") {
        Type = 71;
        this.paytovendorForm.patchValue({ ntype: "71"})
      } else  {
        Type = 70;
        this.paytovendorForm.patchValue({ ntype: "70"})
      }
    }
    let Fields = ["sVendorName", "sTAXID", "sAddress"];
  

    if (Type == 71 || isOnetime == true) {
    
      this.ArrVendor = this.DataVendor.filter(f => f.IsOnetimeVendor === true).map(re => ({ Customer: re.CUSTOMER_CODE + " - " + re.VENDORNAME, CUSTOMER_CODE: re.CUSTOMER_CODE, sAddress: re.ADDRESS, sVendorName: re.VENDORNAME, TAX_NUMBER1: re.TAX_ID, IsOnetimeVendor: re.IsOnetimeVendor }))

      this.IsVendorOneTime = true;
      const httpOptions_VendorOT = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sComCode", this.nComcode)
      };
      let VendorOT = await this.http.get<any>(this.System.SiteName + "api/_System/GetCustomerOneTime", httpOptions_VendorOT).toPromise();
      if (VendorOT) {
        this.ArrVendorName = VendorOT;
      }
      
      this.isThai = true;
      Fields.forEach(function (field) {
        _this.paytovendorForm.controls[field].enable();
        _this.paytovendorForm.controls[field].markAsUntouched({ onlySelf: true })
        _this.paytovendorForm.controls[field].setValidators(Validators.required)
        _this.paytovendorForm.controls[field].setErrors(null);
        _this.paytovendorForm.controls[field].updateValueAndValidity();


      })

      this.FieldOnetimeValid.forEach(function (Item) {
        _this.paytovendorForm.get(Item._Field).markAsUntouched({ onlySelf: true });
        _this.paytovendorForm.controls[Item._Field].setValue(Item._Value);
        _this.paytovendorForm.controls[Item._Field].setValidators(Item._Validator);
        _this.paytovendorForm.controls[Item._Field].setErrors(null);
        _this.paytovendorForm.controls[Item._Field].updateValueAndValidity();
      });
      this.paytovendorForm.patchValue({
        sTAXID: "",
        sVendorName: "",
        sAddress: "",
        sPhoneNumber: "",
        sAmpCode: "",
        sAmpName: "",
        sBranch: "",
        sComcode: "",
        sCountryID: "213",
        txtCountryID: "ประเทศไทย (Thailand)",
        sVendorEmail: "",
        sFaxNumber: "",
        sPostCode: "",
        sProvCode: "",
        sProvName: "",
        sTumbonCode: "",
        sTumbonName: "",
      });

    }
    if (Type != 71 && isOnetime != true) {
      this.ArrVendor = this.DataVendor.filter(f => f.IsOnetimeVendor === false).map(re => ({ Customer: re.CUSTOMER_CODE + " - " + re.VENDORNAME, CUSTOMER_CODE: re.CUSTOMER_CODE, sAddress: re.ADDRESS, sVendorName: re.VENDORNAME, TAX_NUMBER1: re.TAX_ID, IsOnetimeVendor: re.IsOnetimeVendor }))

      this.IsVendorOneTime = false;
      this.ArrVendorName = [];
      Fields.forEach(function (field) {
        _this.paytovendorForm.controls[field].disable();
        _this.paytovendorForm.controls[field].markAsUntouched({ onlySelf: true })
        _this.paytovendorForm.controls[field].setValidators(null)
        _this.paytovendorForm.controls[field].setValue(" ");
        _this.paytovendorForm.controls[field].setErrors(null);
        _this.paytovendorForm.controls[field].updateValueAndValidity();

      })

      this.FieldOnetimeValid.forEach(function (Item) {
        _this.paytovendorForm.controls[Item._Field].setValue("");
        _this.paytovendorForm.controls[Item._Field].setErrors(null);
        _this.paytovendorForm.controls[Item._Field].clearValidators();
      });
    }
    if (changeApprover) {
      //GetApprover
      this.http.get(this.System.SiteName + "api/_Paytovendor/GetApprover/" + this.nComcode + "/" + Type).subscribe((data: Response) => {
        let dataraw: any;
        let Data: any;
        if (data) {
          Data = data[0];
        } else {
          Data = null;
        }

        if (Data != null) {
          if (Data.cActive == "Y") {
            if (Data.IsApprover_1 == false) {
              this.paytovendorForm.controls['ddApprover1'].disable();
              this.paytovendorForm.controls['cSkipApprove1'].setValue(true);
            } else {
              this.paytovendorForm.controls['ddApprover1'].enable();
              this.paytovendorForm.controls['cSkipApprove1'].setValue(false);
              let nUserID = this.DataApprover.filter(f => f.nUserID == Data.name1ID)[0]
              this.paytovendorForm.patchValue({
                ddApprover1: Data.name1,
                sApprove1: nUserID.nUserID
              })
            }
            if (Data.IsApprover_2 == false) {
              this.paytovendorForm.controls['ddApprover2'].enable();
            } else {
              this.paytovendorForm.controls['ddApprover2'].enable();
              let nUserID = this.DataApprover.filter(f => f.nUserID == Data.name2ID)[0]
              this.paytovendorForm.patchValue({
                ddApprover2: Data.name2,
                sApprove2: nUserID.nUserID
              })
            }
          } else if (this.GetApprover.cActive == "N") {
            this.ArrApprover[0] = this.DataApprover.filter(f => f.nRole == 3);
            this.ArrApprover[1] = this.DataApprover.filter(f => f.nRole == 4);
          }
        }

      })
    }
 
    ////AutocompleteApprover
    //this.http.get(location.origin + "/api/Autocomplete/TUserPermission/*/sCompCode/" + this.nComcode + "/nRole/2").subscribe((data: Response) => {
    //  this.DataApprover = data;
    //  this.ArrApprover = this.DataApprover.map(re => re.sName)
    //})
  }
  async onCopyRequestCodeSelect(RequestCode) {
    if (RequestCode != "") {
      let Data: any;
      let lstData = this.DataRequest.filter(user => user.sRequestCode == RequestCode)[0]
      await this.http.get(this.System.SiteName + "api/_paytovendor/GetRequest/" + lstData.sRequestID + "?Copy=true").toPromise().then((data: any) => {
        this.ClearInvoice();
        Data = data.filter(f => f.cActive != 'N');
      })

      if (Data != null) {
        this.paytovendorForm.patchValue({ ntype: Data[0].ntype })
        await this.onTypeSelect(Data[0].sVendorCode, Data[0].IsVendorOneTime);
        this.ArrInvoice = Data;
        this.Checkinvoice();
      }

      this._ArrTumbon = [];
      const httpOptions_Amphur = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sProvCode", Data[0].sProvCode)
      };
      await this.http.get<any>(this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).toPromise().then(res => {
        if (res) {
          this._ArrAmphur = res;
        }
      });
      const httpOptions_Tumbon = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sAmpCode", Data[0].sAmpCode)
      };
      await this.http.get<any>(this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).toPromise().then(res => {
        if (res) {
          this._ArrTumbon = res;
        }
      });
      this.paytovendorForm.patchValue({
        nCopyRequest: Data[0].sRequestID,
        nVendorCode: Data[0].sVendorCode,
        sOtherRefNoFIDocNo: Data[0].sOtherRefNoFIDocNo,
        sDescription: Data[0].sDescription,
        sTAXID: Data[0].sTAXID,
        sVendorName: Data[0].sVendorName,
        cbOffice: Data[0].nOfficeType,
        cbReceiveTypeB2C: Data[0].nReceiveTypeB2C,
        sBranch: Data[0].sVendorBranch,
        sAddress: Data[0].sVendorAddress,
        sCountryID: Data[0].sCountryID,
        sProvCode: Data[0].sProvCode,
        sProvName: Data[0].sProvName,
        sAmpCode: Data[0].sAmpCode,
        sAmpName: Data[0].sAmpName,
        sTumbonCode: Data[0].sTumbonCode,
        sTumbonName: Data[0].sTumbonName,
        sPostCode: Data[0].sPostCode,
        sPhoneNumber: Data[0].sPhoneNumber,
        sFaxNumber: Data[0].sFaxNumber,
        sVendorEmail: Data[0].sVendorEmail,
        sAddressOneTime: Data[0].sAddressOneTime,
        ddApprover1: Data[0].sUserApprove1,
        ddApprover2: Data[0].sUserApprove2,
        sApprove1: Data[0].nApprove1 == null ? null : Data[0].nApprove1,
        sApprove2: Data[0].nApprove2 == null ? null : Data[0].nApprove2,
        cSkipApprove1: Data[0].cSkipApprove1 == "Y" ? true : false,
      });
      if (Data[0].cSkipApprove1 == "Y") {
        this.paytovendorForm.get('ddApprover1').disable()
      } else {
        this.paytovendorForm.get('ddApprover1').enable();
      }
      this.hBranch = Data[0].nOfficeType == 2 ? false : true;
      if (this.hBranch == false) {
        this.paytovendorForm.controls['sBranch'].enable();
        this.paytovendorForm.patchValue({
          sBranch: Data[0].sVendorBranch,
          cbOffice: Data[0].nOfficeType,
        })
      }
    }
  }
  unique = (value, index, self) => {
    return self.indexOf(value) === index
  }
 
  async onVendorSelect(event) {
    let _this = this;
    let taxID = "";

    if (event.item.CUSTOMER_CODE != undefined && event.item.CUSTOMER_CODE != "") {
      await this.onTypeSelect(event.item.CUSTOMER_CODE, this.IsVendorOneTime, false);
      let lstData = this.DataVendor.filter(s => s.CUSTOMER_CODE == event.item.CUSTOMER_CODE)[0];
      if (lstData != "") {
        this._ArrTumbon = [];
        const httpOptions_Amphur = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          }),
          params: new HttpParams()
            .set("sProvCode", lstData.sProvCode)
        };
        await this.http.get<any>(this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).toPromise().then(res => {
          if (res) {
            this._ArrAmphur = res;
          }
        });
        const httpOptions_Tumbon = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          }),
          params: new HttpParams()
            .set("sAmpCode", lstData.sAmpCode)
        };
        await this.http.get<any>(this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).toPromise().then(res => {
          if (res) {
            this._ArrTumbon = res;
          }
        });

        let Amp = this._ArrAmphur.filter(f => f.sAmpCode == lstData.sAmpCode)[0];
        let Country = this._ArrCountry.filter(f => f.sCountryID == lstData.sCountryID)[0];
        let prov = this._ArrProvince.filter(f => f.sProvCode == lstData.sProvCode)[0];
        let tumbon = this._ArrTumbon.filter(f => f.sTumbonCode == lstData.sTumbonCode)[0];
        let value = { sCountryID: lstData.sCountryID == null ? "213" : lstData.sCountryID };
        let events = { item: value };
        await this.OnCountryselect(events);
        let Type: any;
        let type = event.item.CUSTOMER_CODE != undefined && event.item.CUSTOMER_CODE != "" ? event.item.CUSTOMER_CODE : null;
        if (type != null) {
          let stype = type.substring(0, 2);
          if (stype == "RX") {
            Type = 71;
          } else  {
            Type = 70;
          }
        }
        let tax = "";
        if (_this.IsVendorOneTime == true) {
          tax = lstData.TAX_ID == null ? "" : lstData.TAX_ID
        }
        if (_this.IsVendorOneTime == false && Type != 71) {
          tax = lstData.TAX_ID == null ? "-" : lstData.TAX_ID
        }
        if (Type != 71) {
          this.paytovendorForm.patchValue({
            nVendorCode: lstData.CUSTOMER_CODE,
            sTAXID: tax,
            sVendorName: _this.IsVendorOneTime == true ? "" : lstData.VENDORNAME,
            sAddress: _this.IsVendorOneTime == true || lstData.ADDRESS == null ? "" : lstData.ADDRESS,
            sPhoneNumber: _this.IsVendorOneTime == true ? "" : lstData.TEL,
            cbOffice: isNullOrUndefined(lstData.nOfficeType) == true ? 1 : lstData.nOfficeType,
            sAmpCode: _this.IsVendorOneTime == true || lstData.sAmpCode == null ? "" : lstData.sAmpCode,
            sAmpName: _this.IsVendorOneTime == true || isNullOrUndefined(Amp) == true ? "" : Amp.sAmpName,
            sBranch: lstData.sBranch,
            sComcode: lstData.sComcode,
            sCountryID: _this.IsVendorOneTime == true || isNullOrUndefined(lstData.sCountryID) == true ? "213" : lstData.sCountryID,
            txtCountryID: _this.IsVendorOneTime == true || isNullOrUndefined(Country) == true ? "ประเทศไทย (Thailand)" : Country.sCountryName,
            sVendorEmail: _this.IsVendorOneTime == true ? "" : lstData.sEMAIL,
            sFaxNumber: _this.IsVendorOneTime == true ? "" : lstData.sFaxNumber,
            sPostCode: _this.IsVendorOneTime == true ? "" : lstData.sPostCode,
            sProvCode: _this.IsVendorOneTime == true ? "" : lstData.sProvCode == null ? "" : lstData.sProvCode,
            sProvName: _this.IsVendorOneTime == true || isNullOrUndefined(prov) == true ? "" : prov.sProvname,
            sTumbonCode: _this.IsVendorOneTime == true || lstData.sTumbonCode == null ? "" : lstData.sTumbonCode,
            sTumbonName: _this.IsVendorOneTime == true || isNullOrUndefined(tumbon) == true ? "" : tumbon.sTumbonName
          });

          if (lstData.nOfficeType == 1 || isNullOrUndefined(lstData.nOfficeType) == true) {
            this.paytovendorForm.controls['sBranch'].disable();
          }
        } else {
        
          this.paytovendorForm.patchValue({
            nVendorCode: lstData.CUSTOMER_CODE,
          });
        }
        if (isNullOrUndefined(lstData.sCountryID) == true) {
          this.isThai = true;
          this.paytovendorForm.patchValue({
            txtCountryID: "ประเทศไทย (Thailand)",
            sCountryID: "213",
            sProvCode: "",
            sAmpCode: "",
            sTumbonCode: "",
            sPostCode: "",
            sPhoneNumber: "",
            sFaxNumber: "",
            sVendorEmail: "",
            sAddressOneTime: "",
          })
          //ProvCode
          await this.http.get<any>(this.System.SiteName + "api/_System/GetProvCode").toPromise().then(res => {
            if (res) {
              this._ArrProvince = res;
            }
          });
        }
      } else {
        this.paytovendorForm.patchValue({
          nVendorCode: null,
          sTAXID: null,
          sVendorName: null,
          cbOffice: 1,
          sBranch: null,
          sAddress: null,
        })
      }
    } if (this.ArrInvoice.filter(f => f.cActive != 'N').length > 0) {
      let lstData = _this.DataVendor.filter(s => s.CUSTOMER_CODE == event.item.CUSTOMER_CODE)[0];
      this._ArrTumbon = [];
      const httpOptions_Amphur = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sProvCode", lstData.sProvCode)
      };
      this.http.get<any>(this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).subscribe(res => {
        if (res) {
          this._ArrAmphur = res;
        }
      });
      const httpOptions_Tumbon = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sAmpCode", lstData.sAmpCode)
      };
      this.http.get<any>(this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).subscribe(res => {
        if (res) {
          this._ArrTumbon = res;
        }
      });
      this.ArrInvoice.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        let taxID = "";
        if (lstData != "") {
          if (lstData.TAX_NUMBER3 != null) {
            taxID = lstData.TAX_NUMBER3
          } else if (lstData.TAX_NUMBER3 == null && lstData.TAX_NUMBER2 != null) {
            taxID = lstData.TAX_NUMBER2;
          } else {
            taxID = lstData.TAX_NUMBER1;
          }
        }
        let str;
        if (event.item.CUSTOMER_CODE != null) {
          let isonetime = event.item.IsOnetimeVendor;
          if (isonetime) {
            str = 71;
          } else {
            str = 70
          }
        }
        if (str == 70) {
          if (_IsNullOrEmpty(lstData.VENDORNAME) || _IsNullOrEmpty(lstData.ADDRESS)) {
            _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.Desc_Specify_AddInvoice, undefined)
            return false;
          }
        }
        let Amp = _this._ArrAmphur.filter(f => f.sAmpCode == lstData.sAmpCode)[0];
        let prov = _this._ArrProvince.filter(f => f.sProvCode == lstData.sProvCode)[0];
        let tumbon = _this._ArrTumbon.filter(f => f.sTumbonCode == lstData.sTumbonCode)[0];

        let Type: any;
        let type = event.item.CUSTOMER_CODE != undefined && event.item.CUSTOMER_CODE != "" ? event.item.CUSTOMER_CODE : null;
        if (type != null) {
          let stype = type.substring(0, 2);
          if (stype == "RX") {
            Type = 71;
            _this.IsVendorOneTime = true;
          } else  {
            Type = 70;
          }
        }
        let tax = ""
        if (_this.IsVendorOneTime == true) {
          tax = lstData.TAX_ID == null ? "" : lstData.TAX_ID
        }
        if (_this.IsVendorOneTime == false && Type != 71) {
          tax = lstData.TAX_ID == null ? "-" : lstData.TAX_ID
        }
        let address = ""
        if (_this.IsVendorOneTime == true) {
          address = lstData.ADDRESS == null ? "" : lstData.ADDRESS
        }
        if (_this.IsVendorOneTime == false && Type != 71) {
          address = lstData.ADDRESS == null ? "-" : lstData.ADDRESS
        }

        invoice.IsVendorOneTime = lstData.IsOnetimeVendor;
        invoice.sVendorCode = lstData.CUSTOMER_CODE;
        invoice.sTAXID = tax;
        invoice.sVendorName = _this.IsVendorOneTime == true ? "" : lstData.VENDORNAME;
        invoice.cbOffice = isNullOrUndefined(lstData.nOfficeType) == true ? 1 : lstData.nOfficeType;
        invoice.sVendorBranch = lstData.sBranch;
        invoice.sVendorAddress = address;
        invoice.sCountryID = _this.IsVendorOneTime == true || lstData.sCountryID == null ? "213" : lstData.sCountryID;
        invoice.sProvCode = _this.IsVendorOneTime == true || lstData.sProvCode == null ? "" : prov.sProvCode;
        invoice.sProvName = _this.IsVendorOneTime == true || prov == null ? lstData.sProvName : prov.sProvname;
        invoice.sAmpCode = _this.IsVendorOneTime == true || lstData.sAmpCode == null ? "" : Amp.sAmpCode;
        invoice.sAmpName = _this.IsVendorOneTime == true || Amp == null ? lstData.sAmpName : Amp.sAmpName;
        invoice.sTumbonCode = _this.IsVendorOneTime == true || lstData.sTumbonCode == null ? "" : tumbon.sTumbonCode;
        invoice.sTumbonName = _this.IsVendorOneTime == true || tumbon == null ? lstData.sTumbonName : tumbon.sTumbonName;
        invoice.sPostCode = _this.IsVendorOneTime == true || lstData.sPostCode == null ? "" : lstData.sPostCode;
        invoice.sPhoneNumber = _this.IsVendorOneTime == true || lstData.TEL == null ? "" : lstData.TEL;
        invoice.sFaxNumber = _this.IsVendorOneTime == true || lstData.sFaxNumber == null ? "" : lstData.sFaxNumber;
        invoice.sVendorEmail = _this.IsVendorOneTime == true || lstData.sEMAIL == null ? "" : lstData.sEMAIL;
        // invoice.sAddressOneTime = data.sAddressOneTime;
      })
    }
  }
  //#region "Onetime"
  checkrange() {
    let _this = this;
    var st = this.paytovendorForm.get('nVendorCode').value.length;
    if (st > 10) {
      let clear = function () {
        _this.paytovendorForm.get('nVendorCode').setValue("");
      }
      this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.DescOneVendorLength, clear)
    }

  }
  async OnCountryselect(event) {
    if (event.item.sCountryID != "213") {
      this._ArrProvince = [];
      this.isThai = true;
      this.paytovendorForm.patchValue({
        sCountryID: event.item.sCountryID,
        sProvCode: "",
        sProvName: "",
        sAmpCode: "",
        sAmpName: "",
        sTumbonCode: "",
        sTumbonName: "",
        sPostCode: "",
        sPhoneNumber: "",
        sFaxNumber: "",
        sVendorEmail: "",
        sAddressOneTime: "",
      })

    } else {
      //ProvCode
      await this.http.get<any>(this.System.SiteName + "api/_System/GetProvCode").toPromise().then(res => {
        if (res) {
          this._ArrProvince = res;
        }
      });
      this.isThai = true;
      this.paytovendorForm.patchValue({
        sCountryID: event.item.sCountryID,
        sProvCode: "",
        sProvName: "",
        sAmpCode: "",
        sAmpName: "",
        sTumbonCode: "",
        sTumbonName: "",
        sPostCode: "",
        sPhoneNumber: "",
        sFaxNumber: "",
        sVendorEmail: "",
        sAddressOneTime: "",
      })
    }
    if (this.ArrInvoice.filter(f => f.cActive != 'N').length > 0) {
      this.ArrInvoice.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sCountryID = event.item.sCountryID == null ? "" : event.item.sCountryID;
      })
    }
  }
  OnChangeAmphor(event) {
    let txtsProvName = this.paytovendorForm.get('sProvName').value
    //Amphur
    this._ArrTumbon = [];
    const httpOptions_Amphur = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sProvCode", event.item.sProvCode)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).subscribe(res => {
      if (res) {
        this._ArrAmphur = res;
      } else {
        this._ArrAmphur = [];
      }
    });
    if ((this.paytovendorForm.get('sCountryID').value != "213" || this.sAmphorNoResult == false) && !_IsNullOrEmpty(txtsProvName)) {
      this.paytovendorForm.patchValue({
        sProvName: event.value,
        sProvCode: isNullOrUndefined(event.item.sProvCode) == true ? null : event.item.sProvCode,
      });
      if (this.ArrInvoice.filter(f => f.cActive != 'N').length > 0) {
        this.ArrInvoice.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          invoice.sProvName = event.value;
          invoice.sProvCode = isNullOrUndefined(event.item.sProvCode) == true ? null : event.item.sProvCode;
        })
      }
    } else if (this.sAmphorNoResult == true && this.paytovendorForm.get('sCountryID').value == "213") {
      this.paytovendorForm.patchValue({
        sProvName: null,
        sProvCode: isNullOrUndefined(event.item.sProvCode) == true ? null : event.item.sProvCode,
      });
    } else if (this.sAmphorNoResult == false && _IsNullOrEmpty(txtsProvName) && this.paytovendorForm.get('sCountryID').value == "213") {
      this.paytovendorForm.patchValue({
        sProvName: null,
        sProvCode: null,
      });
    }
    //------------------------------------------------------- อำเภอเปลี่ยน อย่างอื่นก็ต้องเคลีย----------------------
    this.paytovendorForm.patchValue({
      sTumbonName: null,
      sTumbonCode: null,
      sAmpName: null,
      sAmpCode: null,
    });
    if (this.ArrInvoice.filter(f => f.cActive != 'N').length > 0) {
      this.ArrInvoice.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sTumbonName = null
        invoice.sTumbonCode = null
        invoice.sAmpName = null
        invoice.sAmpCode = null
      })
    }
  }
  //Amphur
  OnChangeTumbon(event) {
    let txtsAmpName = this.paytovendorForm.get('sAmpName').value
    //Tumbon
    const httpOptions_Tumbon = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sAmpCode", event.item.sAmpCode)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).subscribe(res => {
      if (res) {
        this._ArrTumbon = res;
      } else {
        this._ArrTumbon = [];
      }
    });
    if ((this.paytovendorForm.get('sCountryID').value != "213" || this.sTumbonNoResult == false) && !_IsNullOrEmpty(txtsAmpName)) {
      this.paytovendorForm.patchValue({
        sAmpName: event.value,
        sAmpCode: isNullOrUndefined(event.item.sAmpCode) == true ? null : event.item.sAmpCode,
      });
      if (this.ArrInvoice.filter(f => f.cActive != 'N').length > 0) {
        this.ArrInvoice.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          invoice.sAmpName = event.value;
          invoice.sAmpCode = isNullOrUndefined(event.item.sAmpCode) == true ? null : event.item.sAmpCode;
        })
      }
    }
    else if (this.sTumbonNoResult == true && this.paytovendorForm.get('sCountryID').value == "213") {
      this.paytovendorForm.patchValue({
        sAmpName: null,
        sAmpCode: isNullOrUndefined(event.item.sAmpCode) == true ? null : event.item.sAmpCode,
      });
    }
    else if (this.sTumbonNoResult == false && _IsNullOrEmpty(txtsAmpName) && this.paytovendorForm.get('sCountryID').value == "213") {
      this.paytovendorForm.patchValue({
        sAmpName: null,
        sAmpCode: null,
      });
    }
    //------------------------------------------------------- อำเภอเปลี่ยน อย่างอื่นก็ต้องเคลีย------
    this.paytovendorForm.patchValue({
      sTumbonName: null,
      sTumbonCode: null,

    });
    if (this.ArrInvoice.filter(f => f.cActive != 'N').length > 0) {
      this.ArrInvoice.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sTumbonName = null
        invoice.sTumbonCode = null
      })
    }
  }
  OnChangeSubDistrict(event) {
    let txtsTumbonName = this.paytovendorForm.get('sTumbonName').value

    if ((this.paytovendorForm.get('sCountryID').value != "213" || this.sSubDistrictNoResult == false) && !_IsNullOrEmpty(txtsTumbonName)) {
      this.paytovendorForm.patchValue({
        sTumbonName: event.value,
        sTumbonCode: isNullOrUndefined(event.item.sTumbonCode) == true ? null : event.item.sTumbonCode,
      });
      if (this.ArrInvoice.filter(f => f.cActive != 'N').length > 0) {
        this.ArrInvoice.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          invoice.sTumbonName = event.value;
          invoice.sTumbonCode = isNullOrUndefined(event.item.sTumbonCode) == true ? null : event.item.sTumbonCode;
        })
      }
    } else if (this.sSubDistrictNoResult == true && this.paytovendorForm.get('sCountryID').value == "213") {
      this.paytovendorForm.patchValue({
        sTumbonName: null,
        sTumbonCode: isNullOrUndefined(event.item.sTumbonCode) == true ? null : event.item.sTumbonCode,
      });
    }
    else if (this.sSubDistrictNoResult == false && _IsNullOrEmpty(txtsTumbonName) && this.paytovendorForm.get('sCountryID').value == "213") {
      this.paytovendorForm.patchValue({
        sTumbonName: null,
        sTumbonCode: null,
      });
    }
  }
  async VendorNameChange(event) {
    let _this = this;
    let lstData = event.item;
    let check = this.ArrVendorName.filter(f => f.sVendorName == lstData.sVendorName)[0];
    let sVendorName = this.paytovendorForm.get('sVendorName').value;
    lstData = check;
    if (check != null && !_IsNullOrEmpty(sVendorName)) {
      this._ArrTumbon = [];
      const httpOptions_Amphur = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sProvCode", lstData.sProvCode)
      };
      await this.http.get<any>(this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).toPromise().then(res => {
        if (res) {
          this._ArrAmphur = res;
        }
      });
      const httpOptions_Tumbon = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sAmpCode", lstData.sAmpCode)
      };
      await this.http.get<any>(this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).toPromise().then(res => {
        if (res) {
          this._ArrTumbon = res;
        }
      });
      let Amp = this._ArrAmphur.filter(f => f.sAmpCode == lstData.sAmpCode)[0];
      let Country = this._ArrCountry.filter(f => f.sCountryID == lstData.sCountryID)[0];
      let prov = this._ArrProvince.filter(f => f.sProvCode == lstData.sProvCode)[0];
      let tumbon = this._ArrTumbon.filter(f => f.sTumbonCode == lstData.sTumbonCode)[0];
      let value = { sCountryID: lstData.sCountryID == null ? "" : lstData.sCountryID };
      let event = { item: value };
      await this.OnCountryselect(event).then();
      this.paytovendorForm.patchValue({
        sTAXID: _IsNullOrEmpty(lstData.sTAXID) ? "" : lstData.sTAXID,
        sAddress: lstData.sAddress == null ? "" : lstData.sAddress,
        sPhoneNumber: lstData.TEL,
        cbOffice: isNullOrUndefined(lstData.nOfficeType) == true ? 1 : lstData.nOfficeType,
        sAmpCode: lstData.sAmpCode == null ? "" : lstData.sAmpCode,
        sAmpName: isNullOrUndefined(Amp) == true ? lstData.sAmpName : Amp.sAmpName,
        sBranch: lstData.sBranch,
        sComcode: lstData.sComcode,
        sCountryID: isNullOrUndefined(lstData.sCountryID) == true ? "213" : lstData.sCountryID,
        txtCountryID: isNullOrUndefined(Country) == true ? "ประเทศไทย (Thailand)" : Country.sCountryName,
        sVendorEmail: lstData.sEMAIL,
        sFaxNumber: lstData.sFaxNumber,
        sPostCode: lstData.sPostCode,
        sProvCode: lstData.sProvCode == null ? "" : lstData.sProvCode,
        sProvName: isNullOrUndefined(prov) == true ? lstData.sProvName : prov.sProvname,
        sTumbonCode: lstData.sTumbonCode == null ? "" : lstData.sTumbonCode,
        sTumbonName: isNullOrUndefined(tumbon) == true ? lstData.sTumbonName : tumbon.sTumbonName
      });
      if (lstData.nOfficeType == 1 || isNullOrUndefined(lstData.nOfficeType) == true) {
        this.paytovendorForm.controls['sBranch'].disable();
      }
      if (lstData.sCountryID != "213") {
        let sfield = ["sProvCode", "sAmpCode", "sTumbonCode", "sPostCode", "sPhoneNumber", "sFaxNumber", "sProvName", "sAmpName", "sTumbonName"]
        //sfield.forEach(function (value) {
        //  _this.paytovendorForm.controls[value].disable();
        //  _this.paytovendorForm.controls[value].clearValidators();
        //  _this.paytovendorForm.controls[value].setValidators(null);
        //  _this.paytovendorForm.controls[value].setErrors({ 'invalid': false });
        //  _this.paytovendorForm.controls[value].markAsUntouched({ onlySelf: true });
        //  _this.paytovendorForm.controls[value].updateValueAndValidity();

        //})
      } else {
        this.isThai = true;
        let sfield = ["txtCountryID", "sProvCode", "sAmpCode", "sTumbonCode", "sProvName", "sAmpName", "sTumbonName"]
        // "sPostCode", "sPhoneNumber", "sFaxNumber",
        //  this.isThai = false;
        sfield.forEach(function (value) {
          _this.paytovendorForm.controls[value].enable();
          _this.paytovendorForm.controls[value].setValidators([Validators.required]);
          _this.paytovendorForm.controls[value].updateValueAndValidity();
        })
        let sfieldS = ["sPostCode", "sPhoneNumber", "sFaxNumber"]
        sfieldS.forEach(function (value) {
          _this.paytovendorForm.controls[value].enable();
          _this.paytovendorForm.controls[value].updateValueAndValidity();
        })
        _this.paytovendorForm.controls["sVendorEmail"].enable();
        _this.paytovendorForm.controls["sVendorEmail"].setValidators(Validators.email);
        _this.paytovendorForm.controls["sVendorEmail"].updateValueAndValidity();
      } if (lstData.sCountryID == null && this.IsVendorOneTime == true) {
        let sfield = ["txtCountryID", "sProvCode", "sAmpCode", "sTumbonCode", "sProvName", "sAmpName", "sTumbonName"]
        //  "sPostCode", "sPhoneNumber", "sFaxNumber",
        //  this.isThai = false;
        sfield.forEach(function (value) {
          _this.paytovendorForm.controls[value].enable();
          _this.paytovendorForm.controls[value].setValidators([Validators.required]);
          _this.paytovendorForm.controls[value].updateValueAndValidity();
        })
        let sfieldS = ["sPostCode", "sPhoneNumber", "sFaxNumber"]
        sfieldS.forEach(function (value) {
          _this.paytovendorForm.controls[value].enable();
          _this.paytovendorForm.controls[value].updateValueAndValidity();
        })
        _this.paytovendorForm.controls["sVendorEmail"].enable();
        _this.paytovendorForm.controls["sVendorEmail"].setValidators(Validators.email);
        _this.paytovendorForm.controls["sVendorEmail"].updateValueAndValidity();
        this.isThai = true;
        this.paytovendorForm.patchValue({
          txtCountryID: "ประเทศไทย (Thailand)",
          sCountryID: "213",
          sProvCode: "",
          sAmpCode: "",
          sTumbonCode: "",
          sPostCode: "",
          sPhoneNumber: "",
          sFaxNumber: "",
          sVendorEmail: "",
          sAddressOneTime: "",
        })
        //ProvCode
        await this.http.get<any>(this.System.SiteName + "api/_System/GetProvCode").toPromise().then(res => {
          if (res) {
            this._ArrProvince = res;
          }
        });
      }
    } else {
      lstData = {};
      this.paytovendorForm.patchValue({
        txtCountryID: "ประเทศไทย (Thailand)",
        sTAXID: null,
        cbOffice: 1,
        sBranch: null,
        sAddress: null,
        sCountryID: "213",
        sProvCode: "",
        sProvName: "",
        sAmpCode: "",
        sAmpName: "",
        sTumbonCode: "",
        sTumbonName: "",
        sPostCode: "",
        sPhoneNumber: "",
        sFaxNumber: "",
        sVendorEmail: "",
        sAddressOneTime: "",
      })
    } if (this.ArrInvoice.filter(f => f.cActive != 'N').length > 0) {
      this.ArrInvoice.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        //if (_IsNullOrEmpty(lstData.VENDORNAME) || _IsNullOrEmpty(lstData.ADDRESS) || _IsNullOrEmpty(lstData.TAX_ID)) {
        //  _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.Desc_Specify_AddInvoice, undefined)
        //  // return false;
        //}
        let Amp = _this._ArrAmphur.filter(f => f.sAmpCode == lstData.sAmpCode)[0];
        let prov = _this._ArrProvince.filter(f => f.sProvCode == lstData.sProvCode)[0];
        let tumbon = _this._ArrTumbon.filter(f => f.sTumbonCode == lstData.sTumbonCode)[0];

        invoice.sTAXID = _IsNullOrEmpty(lstData.TAX_ID) ? "" : lstData.TAX_ID;
        invoice.sVendorName = isNullOrUndefined(lstData.sVendorName) ? event.value : lstData.sVendorName;
        invoice.cbOffice = isNullOrUndefined(lstData.nOfficeType) == true ? 1 : lstData.nOfficeType;
        invoice.sVendorBranch = isNullOrUndefined(lstData.sBranch) ? "" : lstData.sBranch;
        invoice.sVendorAddress = isNullOrUndefined(lstData.ADDRESS) ? "" : lstData.ADDRESS;
        invoice.sCountryID = isNullOrUndefined(lstData.sCountryID) ? "213" : lstData.sCountryID;
        invoice.sProvCode = isNullOrUndefined(lstData.sProvCode) ? "" : prov.sProvCode;
        invoice.sProvName = prov == null ? lstData.sProvName : prov.sProvname;
        invoice.sAmpCode = isNullOrUndefined(lstData.sAmpCode) ? "" : Amp.sAmpCode;
        invoice.sAmpName = Amp == null ? lstData.sAmpName : Amp.sAmpName;
        invoice.sTumbonCode = isNullOrUndefined(lstData.sTumbonCode) ? "" : tumbon.sTumbonCode;
        invoice.sTumbonName = tumbon == null ? lstData.sTumbonName : tumbon.sTumbonName;
        invoice.sPostCode = isNullOrUndefined(lstData.sPostCode) ? "" : lstData.sPostCode;
        invoice.sPhoneNumber = isNullOrUndefined(lstData.TEL) ? "" : lstData.TEL;
        invoice.sFaxNumber = isNullOrUndefined(lstData.sFaxNumber) ? "" : lstData.sFaxNumber;
        invoice.sVendorEmail = isNullOrUndefined(lstData.sEMAIL) ? "" : lstData.sEmail;
        // invoice.sAddressOneTime = data.sAddressOneTime;

      })
    }
    if (this.IsVendorOneTime == true) {
      if (this.ArrInvoice.filter(f => f.cActive != 'N').length > 0) {
        this.ArrInvoice.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          if (event.value != null && !_IsNullOrEmpty(sVendorName)) {
            invoice.sVendorName = event.value == null ? "" : event.value;
          } else {
            invoice.sVendorName = "";
          }
        })
      }
    }
    if (this.IsVendorOneTime == false) {
      if (this.ArrInvoice.filter(f => f.cActive != 'N').length > 0) {
        this.ArrInvoice.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          if (event.target.value != null && !_IsNullOrEmpty(sVendorName)) {
            invoice.sVendorName = event.target.value == null ? "" : event.target.value;
          } else {
            invoice.sVendorName = "";
          }
        })
      }
    }
  }
  CommentChange(event) {
    this.paytovendorForm.patchValue({
      sComment: event.target.value,
    });
    this.sComment = event.target.value == null ? "" : event.target.value;
  }
  CommentChangeSSC(event) {
    this.paytovendorForm.patchValue({
      sCommentSSC: event.target.value,
    });
    this.sCommentSSC = event.target.value == null ? "" : event.target.value;
  }
  TAXIDChange(event) {
    if (this.ArrInvoice.filter(f => f.cActive != 'N').length > 0) {
      this.ArrInvoice.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sTAXID = event.target.value == null ? "" : event.target.value;
      })
    }
  }
  AddressChange(event) {
    if (this.ArrInvoice.filter(f => f.cActive != 'N').length > 0) {
      this.ArrInvoice.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sVendorAddress = event.target.value == null ? "" : event.target.value;
      })
    }
  }

  BranchChange(event) {
    if (this.ArrInvoice.filter(f => f.cActive != 'N').length > 0) {
      this.ArrInvoice.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sVendorBranch = event.target.value == null ? "" : event.target.value;
      })
    }
  }
  PostCodeChange(event) {
    if (this.ArrInvoice.filter(f => f.cActive != 'N').length > 0) {
      this.ArrInvoice.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sPostCode = event.target.value == null ? "" : event.target.value;
      })
    }
  }
  PhoneNumberChange(event) {
    if (this.ArrInvoice.filter(f => f.cActive != 'N').length > 0) {
      this.ArrInvoice.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sPhoneNumber = event.target.value == null ? "" : event.target.value;
      })
    }
  }
  FaxNumberChange(event) {
    if (this.ArrInvoice.filter(f => f.cActive != 'N').length > 0) {
      this.ArrInvoice.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sFaxNumber = event.target.value == null ? "" : event.target.value;
      })
    }
  }
  EmailChange(event) {
    if (this.ArrInvoice.filter(f => f.cActive != 'N').length > 0) {
      this.ArrInvoice.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
        invoice.sVendorEmail = event.target.value == null ? "" : event.target.value;
      })
    }

  }
  //#region "Onetime"

  formatnumber(Digit: number, Grouping: boolean, Data: number): string {
    var currencyChars = new RegExp('[\,]', 'g');

    if (isNaN(Data)) {
      return null;
    } else {
      var item = parseFloat(String(Data).replace(currencyChars, ''));
      return new Intl.NumberFormat('en', { maximumFractionDigits: Digit, minimumFractionDigits: Digit, useGrouping: Grouping }).format(item);
    }
  }
  //#endregoin
  keyPress(event: any, byTotal) {
    let Total: number = _ParseFloatToZero(this.paytovendorForm.value.nTotalAmountVat)
    let Vat: number = this.paytovendorForm.value.nVat == null ? 0 : this.paytovendorForm.value.nVat;
    let WHTRate: number = this.paytovendorForm.value.nWHTRate
    let WHTRate2: number = this.paytovendorForm.value.nWHTRate2
    let VatAmount: number = Total * Vat;
    let include = this.formatnumber(2, true, VatAmount + Total);
    let nTotalAmountInvoice = this._ConvertToDecimal(include);
    this.paytovendorForm.patchValue({
      nTotalAmountInvoice: nTotalAmountInvoice,
      nVatAmount: this._ConvertToDecimal(VatAmount.toFixed(2)),
    })

    let WHTBase: number = 0;
    let WHTBase2: number = 0;
    
    if (WHTRate !== null && WHTRate !== 0) {
      if (byTotal) {
        WHTBase = Number(Total);
      }
      else {
        let nWHTBase: number = _ParseFloatToZero(this.paytovendorForm.controls['nWHTBase'].value).toFixed(2);
        WHTBase = Number(nWHTBase);
      }
    }
    
    let nWHTBase2: number = _ParseFloatToZero(this.paytovendorForm.controls['nWHTBase2'].value).toFixed(2);
    WHTBase2 = Number(nWHTBase2);

    let WHTAmount: number = WHTBase * WHTRate / 100;
    let WHTAmount2: number = WHTBase2 * WHTRate2 / 100;

    this.paytovendorForm.patchValue({
      nWHTVal: this._ConvertToDecimal(WHTAmount.toFixed(2)),
      _nWHTVal: this._ConvertToDecimal(WHTAmount.toFixed(2)),
      nWHTVal2: this._ConvertToDecimal(WHTAmount2.toFixed(2)),
      _nWHTVal2: this._ConvertToDecimal(WHTAmount2.toFixed(2)),
      nWHTBase: this._ConvertToDecimal(WHTBase.toFixed(2)),
      nWHTBase2: this._ConvertToDecimal(WHTBase2.toFixed(2)),
    })
  }
  keyVat(event: any) {
    let Total: number = _ParseFloatToZero(this.paytovendorForm.value.nTotalAmountVat)
    let include = this.formatnumber(2, true, Total + Number(event.target.value));
    this.paytovendorForm.patchValue({
      nTotalAmountInvoice: this._ConvertToDecimal(include),
    })
  }
  KeyWithholdingRate(event: any, mode: number) {
    let WHYRate: number = event.target.value;
    
    if (mode === 1) {
    let Total: number = _ParseFloatToZero(this.paytovendorForm.value.nWHTBase).toFixed(2)
    let nWHTVal = this._ConvertToDecimal((Number(Total * (WHYRate / 100))).toFixed(2));
    
      this.paytovendorForm.patchValue({
        WHYRate: WHYRate,
        nWHTVal: nWHTVal,
        _nWHTVal: nWHTVal,
      });
      if (WHYRate){
        this.paytovendorForm.patchValue({
          nWHTRate: WHYRate,
        });
      }
    }
    else{
    let Total: number = _ParseFloatToZero(this.paytovendorForm.value.nWHTBase2).toFixed(2)
    let nWHTVal2 = this._ConvertToDecimal((Number(Total * (WHYRate / 100))).toFixed(2));
    
      this.paytovendorForm.patchValue({
        WHYRate2: WHYRate,
        nWHTVal2: nWHTVal2,
        _nWHTVal2: nWHTVal2,
      });
      if (WHYRate){
        this.paytovendorForm.patchValue({
          nWHTRate2: WHYRate,
        });
      }
    }
   
  }
  KeyWithholdingAmount(mode: number){
    const _this = this;
    let ddlWithholdingTax = _this.paytovendorForm.value.ddlWithholdingTax;
    if (ddlWithholdingTax !== '0' && ddlWithholdingTax !== 0) {
      let nWHTVal: number = 0;
      let _nWHTVal: number = 0;
      let nWHTValNew: any;
      let _nWHTValNew: any;
      if (mode === 1) {
          nWHTVal = Number(_ParseFloatToZero(_this.paytovendorForm.value.nWHTVal).toFixed(2));
          _nWHTVal = Number(_ParseFloatToZero(_this.paytovendorForm.value._nWHTVal).toFixed(2));
          nWHTValNew = _this.paytovendorForm.value.nWHTVal;
          _nWHTValNew = _this.paytovendorForm.value._nWHTVal;
      }
      else {
          nWHTVal = Number(_ParseFloatToZero(_this.paytovendorForm.value.nWHTVal2).toFixed(2));
          _nWHTVal = Number(_ParseFloatToZero(_this.paytovendorForm.value._nWHTVal2).toFixed(2));
          nWHTValNew = this.paytovendorForm.value.nWHTVal2;
          _nWHTValNew = this.paytovendorForm.value._nWHTVal2;
      }
      if (Math.abs(nWHTVal - _nWHTVal) > 1){
        nWHTValNew = _nWHTValNew;
        _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.Desc_Error_Amount, null)
      }
      if (mode === 1) {
        _this.paytovendorForm.patchValue({
          nWHTVal: nWHTValNew,
          _nWHTVal: _nWHTValNew,
        });
      }
      else {
        _this.paytovendorForm.patchValue({
          nWHTVal2: nWHTValNew,
          _nWHTVal2: _nWHTValNew,
        })
      }
    }
  }

  KeyWithholding(event: any, mode: number) {
    // let nWHTVal = this._ConvertToDecimal((Number(event.target.value)).toFixed(2));
    if (event.target.value === '') {
      if (mode === 1) {
        this.paytovendorForm.patchValue({
          nWHTVal: '0.00',
          _nWHTVal: '0.00',
        });
      }
      else {
        this.paytovendorForm.patchValue({
          nWHTVal2: '0.00',
          _nWHTVal2: '0.00',
        })
      }
    }
  }
  KeyWithholdingBase(event: any, mode: number) {
    // let nWHTVal = this._ConvertToDecimal((Number(event.target.value)).toFixed(2));
    if (event.target.value === '') {
      if (mode === 1) {
        this.paytovendorForm.patchValue({
          nWHTBase: '0.00',
        });
      }
      else {
        this.paytovendorForm.patchValue({
          nWHTBase2: '0.00',
        })
      }
    }
  }
  onWithholdingTaxSelect(mode: number, isEdit: boolean) {
    if (mode === 1) {
      let ddlWithholdingTax = this.paytovendorForm.value.ddlWithholdingTax;
      let nWHTBase = _ParseFloatToZero(this.paytovendorForm.value.nWHTBase).toFixed(2);
      let nWHTVal: number = 0;
      let nWHTOther: number = null;
      let nWHTRate = this.WHT.filter(f => f.nRate == ddlWithholdingTax && ddlWithholdingTax !== ' ')[0];
      let nWHT = this.WHT.filter(f => f.nRate == ddlWithholdingTax && ddlWithholdingTax !== ' ')[0];
      if (nWHTRate != null) {
        nWHTRate = nWHTRate.nRate;
      } else {
        nWHTRate = 0;
      }
      if (nWHTRate !== 0) {
        if(nWHTBase === '0.00' || nWHTBase === ''){
          this.paytovendorForm.patchValue({
            nWHTBase: this._ConvertToDecimal((_ParseFloatToZero(this.paytovendorForm.value.nTotalAmountVat)).toFixed(2)),
          });
          nWHTBase = _ParseFloatToZero(this.paytovendorForm.value.nWHTBase).toFixed(2);
        }
      }

      let IsWithholdingTax = nWHTRate == 0 ? true : false;
      if (nWHTRate === 0) IsWithholdingTax = true;
      if (IsWithholdingTax == true && ddlWithholdingTax !== " ") {
        nWHTOther = nWHTRate;
        this.paytovendorForm.controls['nWHTOther'].enable();
        this.paytovendorForm.controls['nWHTOther'].setValidators([Validators.required]);
        this.paytovendorForm.controls['nWHTOther'].setErrors({ 'invalid': true });
        this.paytovendorForm.controls['nWHTOther'].updateValueAndValidity();
        // if (ddlWithholdingTax === '0' || ddlWithholdingTax === 0) {
        //   this.paytovendorForm.controls['nWHTVal'].enable();
        //   this.paytovendorForm.controls['nWHTVal'].setValidators([Validators.required]);
        //   this.paytovendorForm.controls['nWHTVal'].setErrors({ 'invalid': true });
        //   this.paytovendorForm.controls['nWHTVal'].updateValueAndValidity();
        // }
        // else {
        //   this.paytovendorForm.controls['nWHTVal'].disable();
        //   this.paytovendorForm.controls['nWHTVal'].clearValidators();
        //   this.paytovendorForm.controls['nWHTVal'].setValidators(null);
        //   this.paytovendorForm.controls['nWHTVal'].setErrors({ 'invalid': false });
        //   this.paytovendorForm.controls['nWHTVal'].markAsUntouched({ onlySelf: true });
        //   this.paytovendorForm.controls['nWHTVal'].updateValueAndValidity();
        // }
      } else if (IsWithholdingTax == false || ddlWithholdingTax == " ") {
        this.paytovendorForm.controls['nWHTOther'].disable();
        this.paytovendorForm.controls['nWHTOther'].clearValidators();
        this.paytovendorForm.controls['nWHTOther'].setValidators(null);
        this.paytovendorForm.controls['nWHTOther'].setErrors({ 'invalid': false });
        this.paytovendorForm.controls['nWHTOther'].markAsUntouched({ onlySelf: true });
        this.paytovendorForm.controls['nWHTOther'].updateValueAndValidity();
        // this.paytovendorForm.controls['nWHTVal'].disable();
        // this.paytovendorForm.controls['nWHTVal'].clearValidators();
        // this.paytovendorForm.controls['nWHTVal'].setValidators(null);
        // this.paytovendorForm.controls['nWHTVal'].setErrors({ 'invalid': false });
        // this.paytovendorForm.controls['nWHTVal'].markAsUntouched({ onlySelf: true });
        // this.paytovendorForm.controls['nWHTVal'].updateValueAndValidity();
        nWHTVal = Number(nWHTBase * (nWHTRate / 100));
      }
      if (isEdit) {
        this.paytovendorForm.patchValue({
          nWHTID: nWHT == undefined ? null : nWHT.nWHTID,
          nWHTRate: nWHTRate,
          nWHTOther: nWHTOther,
          nWHTVal: this._ConvertToDecimal(nWHTVal.toFixed(2)),
          _nWHTVal: this._ConvertToDecimal(nWHTVal.toFixed(2)),
        });
      }
    }
    else{
      let ddlWithholdingTax2 = this.paytovendorForm.value.ddlWithholdingTax2;
      let nWHTBase2 = _ParseFloatToZero(this.paytovendorForm.value.nWHTBase2).toFixed(2);
      let nWHTVal2: number = 0;
      let nWHTOther2: number = null;
      let nWHTRate2 = this.WHT.filter(f => f.nRate == ddlWithholdingTax2 && ddlWithholdingTax2 !== ' ')[0];
      let nWHT2 = this.WHT.filter(f => f.nRate == ddlWithholdingTax2 && ddlWithholdingTax2 !== ' ')[0];
      if (nWHTRate2 != null) {
        nWHTRate2 = nWHTRate2.nRate;
      } else {
        nWHTRate2 = 0;
      }
      let IsWithholdingTax2 = nWHTRate2 == 0 ? true : false;
      if (nWHTRate2 === 0) IsWithholdingTax2 = true;
      if (IsWithholdingTax2 == true && ddlWithholdingTax2 !== " ") {
        nWHTOther2 = nWHTRate2;
        this.paytovendorForm.controls['nWHTOther2'].enable();
        this.paytovendorForm.controls['nWHTOther2'].setValidators([Validators.required]);
        this.paytovendorForm.controls['nWHTOther2'].setErrors({ 'invalid': true });
        this.paytovendorForm.controls['nWHTOther2'].updateValueAndValidity();
        if (ddlWithholdingTax2 === '0' || ddlWithholdingTax2 === 0) {
          this.paytovendorForm.controls['nWHTVal2'].enable();
          this.paytovendorForm.controls['nWHTVal2'].setValidators([Validators.required]);
          this.paytovendorForm.controls['nWHTVal2'].setErrors({ 'invalid': true });
          this.paytovendorForm.controls['nWHTVal2'].updateValueAndValidity();
        }
        else {
          this.paytovendorForm.controls['nWHTVal2'].disable();
          this.paytovendorForm.controls['nWHTVal2'].clearValidators();
          this.paytovendorForm.controls['nWHTVal2'].setValidators(null);
          this.paytovendorForm.controls['nWHTVal2'].setErrors({ 'invalid': false });
          this.paytovendorForm.controls['nWHTVal2'].markAsUntouched({ onlySelf: true });
          this.paytovendorForm.controls['nWHTVal2'].updateValueAndValidity();
        }
      } else if (IsWithholdingTax2 == false || ddlWithholdingTax2 == " ") {
        this.paytovendorForm.controls['nWHTOther2'].disable();
        this.paytovendorForm.controls['nWHTOther2'].clearValidators();
        this.paytovendorForm.controls['nWHTOther2'].setValidators(null);
        this.paytovendorForm.controls['nWHTOther2'].setErrors({ 'invalid': false });
        this.paytovendorForm.controls['nWHTOther2'].markAsUntouched({ onlySelf: true });
        this.paytovendorForm.controls['nWHTOther2'].updateValueAndValidity();
        this.paytovendorForm.controls['nWHTVal2'].disable();
        this.paytovendorForm.controls['nWHTVal2'].clearValidators();
        this.paytovendorForm.controls['nWHTVal2'].setValidators(null);
        this.paytovendorForm.controls['nWHTVal2'].setErrors({ 'invalid': false });
        this.paytovendorForm.controls['nWHTVal2'].markAsUntouched({ onlySelf: true });
        this.paytovendorForm.controls['nWHTVal2'].updateValueAndValidity();
        nWHTVal2 = Number(nWHTBase2 * (nWHTRate2 / 100));
      }
      if (isEdit) {
        this.paytovendorForm.patchValue({
          nWHTID2: nWHT2 == undefined ? null : nWHT2.nWHTID,
          nWHTRate2: nWHTRate2,
          nWHTOther2: nWHTOther2,
          nWHTVal2: this._ConvertToDecimal(nWHTVal2.toFixed(2)),
          _nWHTVal2: this._ConvertToDecimal(nWHTVal2.toFixed(2)),
        });
      }
    }
   
  }
  onGLSelect(row) {
    this.sGL = this.ArrGL.value.sGL
  }
  async onCostCenterSelect(sCost, row) {
    let _this = this;
    if (sCost != undefined && sCost != "") {
      let lstData = this.DataCostCenter.filter(s => s.COST_CENTER == sCost)[0]
      let nCostCode = lstData.COST_CENTER;
      const httpOptions_IO = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sCompCode", this.nComcode)
      };

      //AutocompleteIO
      await this.http.get(_this.System.SiteName + "api/_System/GetIO2", httpOptions_IO).toPromise().then((data: Response) => {
        this.DataIO = data;
        if (this.DataIO != null) {
          this.ArrMaster[row] = this.DataIO;
        } else {
          this.ArrMaster[row] = ["", ""];
        }
      })
    }
  }
  async AddInvoice() {
    let _this = this;
    if (_IsNullOrEmpty(_this.paytovendorForm.get('sVendorName').value) || _IsNullOrEmpty(_this.paytovendorForm.get('sAddress').value) || _IsNullOrEmpty(_this.paytovendorForm.get('sTAXID').value)) {
      _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.Desc_Specify_AddInvoice, undefined)
      return false;
    }
    let nTotalAmountVat: number = _ParseFloatToZero(this.paytovendorForm.controls['nTotalAmountVat'].value).toFixed(2);
    let nWHTBase: number = _ParseFloatToZero(this.paytovendorForm.controls['nWHTBase'].value).toFixed(2);
    let nWHTBase2: number = _ParseFloatToZero(this.paytovendorForm.controls['nWHTBase2'].value).toFixed(2);

    let base = this._ConvertToDecimal((Number(nWHTBase) + Number(nWHTBase2)).toFixed(2));
    let totalAmount = this._ConvertToDecimal((Number(nTotalAmountVat)).toFixed(2));

    if (totalAmount !== base && base !== '0.00') {
      _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.Desc_Base_TotalNoMatch, undefined)
      return false;
    }

    //#region CheckValidate
    let vatType = this.paytovendorForm.value.ddVatType;
    let datavat = this.VatType.filter(s => s.TAX_CODE == vatType)[0]
    let _FormGroup = this.paytovendorForm;
    let IsValid: boolean = true;
    let FieldValid: string[];
    if (_FormGroup.get("nWHTOther").disabled == true || _FormGroup.get("nWHTOther2").disabled == true) {
      FieldValid = ["sAddress", "sVendorName", "sTAXID", "sName", "dDueDate", "nVendorCode",
        , "dInvoiceDate", "nTotalAmountVat", "txtCountryID", "sProvName", "sAmpName", "sTumbonName"];
    } else {
      FieldValid = ["sAddress", "sName", "dDueDate", "nVendorCode", "sVendorName", "sTAXID",
        , "dInvoiceDate", "nTotalAmountVat", "nWHTOther", "txtCountryID", "sProvName", "sAmpName", "sTumbonName"];
    }
    FieldValid.forEach(function (Field) {
      if (!_FormGroup.get(Field).valid && _FormGroup.get(Field).disabled != true) {
        IsValid = false;
        return false;
      }
      //เช็ค ddTypeVat
      if (vatType != "-1") {
        if (!_FormGroup.get("nVatAmount").valid && datavat.TAX_CODE != "VZ") {
          const control = _FormGroup.get("nVatAmount");
          if (control instanceof FormControl) {
            control.markAsTouched({ onlySelf: true });
            IsValid = false;
            return false;
          }
        }
      } else if (vatType == "-1") {
        const control = _FormGroup.get("nVatAmount");
        if (control instanceof FormControl) {
          control.markAsTouched({ onlySelf: true });
          _FormGroup.get("ddVatType").setErrors({ 'invalid': true })
          _FormGroup.get("ddVatType").markAsTouched({ onlySelf: true });
          IsValid = false;
          return false;
        }
      }
    });

    //เช็ค ArrGL
    if (IsValid) {
      let FieldGLValid: string[];
      FieldGLValid = ["sProfitCenter", "sAmountExcludedVAT", "sText"];
      if (this.isUseGL) {
        FieldGLValid.push("sGL");
      }
      for (let i = 0; i < this.ArrGL.length; i++) {
        FieldGLValid.forEach(function (Field) {
          let FromArray = _FormGroup.get('ArrGL') as FormArray;
          if (!FromArray.at(i).get(Field).valid) {
            IsValid = false;
            return false;
          }
        });
      }
    }
    //#endregion
    if (IsValid) {
      let nWHTRate: any;
      let nWHTRate2: any;
      let arrGl = this.paytovendorForm.value.ArrGL;
      let InvoiceNo = this.paytovendorForm.get('sInvoiceNo').value;
      if (InvoiceNo === '-') InvoiceNo = `Blank_${this.datepipe.transform(Date.now(), 'yyyyMMddHHmmss')}` 
      let VatType = this.paytovendorForm.get('ddVatType').value;
      let sVendorCode = this.paytovendorForm.get('nVendorCode').value;
      let sVendorName = this.paytovendorForm.get('sVendorName').value;
      let sTAXID = this.paytovendorForm.get('sTAXID').value;
      let sVendorBranch = this.paytovendorForm.get('sBranch').value;
      let sVendorAddress = this.paytovendorForm.get('sAddress').value;
      let dInvoiceDate = this.datepipe.transform(this.paytovendorForm.get('dInvoiceDate').value, 'dd/MM/yyyy')
      let sCurrency = this.paytovendorForm.get('ddCurrency').value;
      let nExcludeVAT = Number(this.paytovendorForm.get('nTotalAmountVat').value).toFixed(2);
      let nVatAmount = this.paytovendorForm.get('nVatAmount').value;
      let nIncludeVAT = this.paytovendorForm.get('nTotalAmountInvoice').value;
      let nWHTID = this.paytovendorForm.get('ddlWithholdingTax').value;
      let nWHTID2 = this.paytovendorForm.get('ddlWithholdingTax2').value;
      let nWHT = this.WHT.filter(f => f.nRate == nWHTID && nWHTID !== ' ')[0];
      let nWHT2 = this.WHT.filter(f => f.nRate == nWHTID2 && nWHTID2 !== ' ')[0];
      let nWHTVal = this.paytovendorForm.get('nWHTVal').value;
      let nWHTVal2 = this.paytovendorForm.get('nWHTVal2').value;
      let nWHTBase = this.paytovendorForm.get('nWHTBase').value;
      let nWHTBase2 = this.paytovendorForm.get('nWHTBase2').value;
      let sCountryID = this.paytovendorForm.get('sCountryID').value;
      let sProvCode = this.paytovendorForm.get('sProvCode').value;
      let sProvName = this.paytovendorForm.get('sProvName').value;
      let sAmpCode = this.paytovendorForm.get('sAmpCode').value;
      let sAmpName = this.paytovendorForm.get('sAmpName').value;
      let sTumbonCode = this.paytovendorForm.get('sTumbonCode').value;
      let sTumbonName = this.paytovendorForm.get('sTumbonName').value;
      let sPostCode = this.paytovendorForm.get('sPostCode').value;
      let sPhoneNumber = this.paytovendorForm.get('sPhoneNumber').value;
      let sFaxNumber = this.paytovendorForm.get('sFaxNumber').value;
      let sVendorEmail = this.paytovendorForm.get('sVendorEmail').value;
      let sAddressOneTime = this.paytovendorForm.get('sAddressOneTime').value;
      let nOfficeType = this.paytovendorForm.value.cbOffice;
      let nReceiveTypeB2C = this.paytovendorForm.value.cbReceiveTypeB2C;
      let IsVendorOneTime = this.IsVendorOneTime;
      if (nWHTID == '99' || nWHTID == '0') {
        nWHTRate = Number(this.paytovendorForm.get('nWHTOther').value);
      }
      else if (nWHTID == ' ') {
        nWHTRate = null;
      }
      else {
        nWHTRate = Number(this.paytovendorForm.get('nWHTRate').value);
      }
      if (nWHTID2 == '99' || nWHTID2 == '0') {
        nWHTRate2 = Number(this.paytovendorForm.get('nWHTOther2').value);
      }
      else if (nWHTID2 == ' ') {
        nWHTRate2 = null;
      }
      else {
        nWHTRate2 = Number(this.paytovendorForm.get('nWHTRate2').value);
      }
      let arrsum = arrGl.filter(f => f.IsDelete != true).map(m => this.Check2Digit(m.sAmountExcludedVAT));
      let sumNumber = arrsum.reduce((acc, cur) => (acc + cur), 0).toFixed(2)
      let _this = this;
      let isDup: Boolean;
      let checkDupInvoiceinBase = await this.checkDupinBase(InvoiceNo, dInvoiceDate)
      isDup = (checkDupInvoiceinBase == "Dup") ? true : false
      if (InvoiceNo === '' || InvoiceNo === '-') isDup = false;
      let CheckDupInvoice = this.ArrInvoice.filter(m =>
        (m.sInvoiceNo == InvoiceNo && m.dInvoiceDate == dInvoiceDate && m.IsDelete == false)
      )

      if (CheckDupInvoice.length == 0 && isDup == false) {
        if (sumNumber == Number(_ParseFloatToZero(this.paytovendorForm.value.nTotalAmountVat).toFixed(2))) {
          let wht: any;
          let wht2: any;
          if (nWHT == undefined || nWHT == null) {
            wht = null;
          } 
          if (nWHT2 == undefined || nWHT2 == null) {
            wht2 = null;
          } 
          if (nWHTID == 99) {
            wht = 99;
          } 
          if (nWHTID2 == 99) {
            wht2 = 99;
          } 
          if (nWHT != undefined || nWHT != null) {
            wht = nWHT.nWHTID;
          }
          if (nWHT2 != undefined || nWHT2 != null) {
            wht2 = nWHT2.nWHTID;
          }
          arrGl.filter(f => f.IsDelete != true).forEach(function (value, i: number) {
            let nLine = (_this.ArrInvoice.length >= 1) ? _this.ArrInvoice.filter(f => (f.sInvoiceNo == InvoiceNo && f.dInvoiceDate == dInvoiceDate && f.IsDelete == false)).length : 0;
            let arr = {
              sInvoiceNo: InvoiceNo,
              sVatType: VatType,
              nLine: nLine + 1,
              sGL: value.sGL,
              sCostCenter: value.sCostCenter,
              sIO: value.sIO === "Not Require IO (N/A)" ? null : value.sIO,
              sProfitCenter: value.sProfitCenter,
              sAmount: _ParseFloatToZero(value.sAmountExcludedVAT),
              sText: value.sText,
              cVenderMaster: "M",
              sVendorCode: sVendorCode,
              sVendorName: sVendorName,
              sTAXID: sTAXID,
              sVendorBranch: sVendorBranch,
              sVendorAddress: sVendorAddress,
              dInvoiceDate: dInvoiceDate,
              sCurrency: sCurrency,
              nExcludeVAT: _ParseFloatToZero(nExcludeVAT),
              nVAT: _ParseFloatToZero(nVatAmount),
              nIncludeVAT: _ParseFloatToZero(nIncludeVAT),
              nWHTID: wht,
              nWHTID2: wht2,
              nWHTRate: +nWHTRate,
              nWHTRate2: +nWHTRate2,
              nWHTVal: _ParseFloatToZero(nWHTVal),
              _nWHTVal: _ParseFloatToZero(nWHTVal),
              nWHTVal2: _ParseFloatToZero(nWHTVal2),
              _nWHTVal2: _ParseFloatToZero(nWHTVal2),
              nWHTBase: _ParseFloatToZero(nWHTBase),
              nWHTBase2: _ParseFloatToZero(nWHTBase2),
              nOfficeType: nOfficeType,
              nReceiveTypeB2C: nReceiveTypeB2C,
              nInvoiceType: null,
              sCountryID: sCountryID,
              sProvCode: sProvCode,
              sProvName: sProvName,
              sAmpCode: sAmpCode,
              sAmpName: sAmpName,
              sTumbonCode: sTumbonCode,
              sTumbonName: sTumbonName,
              sPostCode: sPostCode,
              sPhoneNumber: sPhoneNumber,
              sFaxNumber: sFaxNumber,
              sVendorEmail: sVendorEmail,
              sAddressOneTime: sAddressOneTime,
              IsVendorOneTime: IsVendorOneTime,
              dCreateDate: null,
              sCreateBy: "",
              dUpdateDate: null,
              IsDelete: false,
            };
            _this.ArrInvoice.push(arr);
          })
          this.CalGrand();
          this.Checkinvoice();
          this.clearSubinvoice();

          //#region 2021-01-21 Log Save Invoice
          // const options = { headers: { 'Content-Type': 'application/json' } };
          // _this.http.post<any>(_this.System.SiteName + "api/_Paytovendor/LogInvoice", JSON.stringify(_this.ArrInvoice), options).subscribe(res => {

          // })
          //#endregion

          /*    } else {
                this.SW.SwAlert.Warning(this.SW.BoxMsg.Title_info, "!!!!!!!!!", undefined)
              }*/

        } else {
          this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Invoice_TotalNoMatch, undefined)
          return false;
        }
      } else {
        this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Receipt_Duplicate, undefined)
      }
    } else {
      FieldValid.forEach(function (Field) {
        const control = _FormGroup.get(Field);             //{3}
        if (control instanceof FormControl && control.status != "DISABLED") {             //{4}
          control.markAsTouched({ onlySelf: true });
        }
      });
      let FieldGLValid: string[];
      FieldGLValid = ["sProfitCenter", "sAmountExcludedVAT", "sText"];
      if (this.isUseGL) {
        FieldGLValid.push("sGL");
      }
      for (let i = 0; i < this.ArrGL.length; i++) {
        FieldGLValid.forEach(function (Field) {
          let FromArray = _FormGroup.get('ArrGL') as FormArray;
          const control = FromArray.at(i).get(Field);             //{3}
          if (control instanceof FormControl && control.status != "DISABLED") {             //{4}
            control.markAsTouched({ onlySelf: true });
          }
        });
      }
    }
  }
  ClearInvoice() {
    this.paytovendorForm.controls['nVatAmount'].enable();
    this.paytovendorForm.controls["nVatAmount"].setValidators([Validators.required]);
    this.paytovendorForm.controls["nVatAmount"].updateValueAndValidity();
    this.paytovendorForm.controls['nWHTOther'].disable();
    this.paytovendorForm.controls['nWHTOther2'].disable();
    let _this = this;
    this.isEdit = false;
    let FieldValid: string[] = ["nVatAmount", "sTAXID", "sVendorName", "nVendorCode", "dInvoiceDate", "ddVatType", "nTotalAmountVat", "txtCountryID", "sProvName", "sAmpName", "sTumbonName"
      , "sPostCode", "sPhoneNumber", "sFaxNumber", "sVendorEmail"];
    for (let i = 0; i < FieldValid.length; i++) {
      _this.paytovendorForm.get(FieldValid[i]).markAsUntouched();
    }
    let sCurrency = _this.ArrInvoice.filter(f => f.IsDelete != true).length > 0 ? _this.paytovendorForm.get("ddCurrency").value : "THB"
    if (_this.ArrInvoice.filter(f => f.IsDelete != true).length == 0) {
      this.paytovendorForm.patchValue({
        nVendorCode: "",
        sTAXID: "",
        sVendorName: "",
        cbOffice: 1,
        sBranch: "",
        sAddress: "",
        sCountryID: "",
        sProvCode: "",
        sProvName: "",
        sAmpCode: "",
        sAmpName: "",
        sTumbonCode: "",
        sTumbonName: "",
        sPostCode: "",
        sPhoneNumber: "",
        sFaxNumber: "",
        sVendorEmail: "",
      });
    } else {
      this.paytovendorForm.patchValue({
        //  nVendorCode: "",
        sInvoiceNo: '-',
        dInvoiceDate: new Date(),
        nTotalAmount: null,
        ddCurrency: sCurrency,
        nVat: null,
        ddVatType: "-1",
        nVatAmount: null,
        nTotalAmountInvoice: null,
        nTotalAmountVat: null,
        ddlWithholdingTax: " ",
        ddlWithholdingTax2: " ",
        nWHTRate: null,
        nWHTRate2: null,
        nWHTOther: null,
        nWHTOther2: null,
        nWHTVal: null,
        _nWHTVal: null,
        nWHTVal2: null,
        _nWHTVal2: null,
        nWHTBase: null,
        nWHTBase2: null,
      })
    }
    if (this.paytovendorForm.get('cbOffice').value == 1) {
      this.paytovendorForm.controls['sBranch'].disable();
    }
    this.ArrMaster = [];
    this.ArrMaster.push(this.ArrIO);
    this.ArrGL.clear()
    this._paytovendorForm.ArrGL.reset();
    this.ArrGL.push(new FormGroup({
      sGL: new FormControl('', Validators.required),
      sCostCenter: new FormControl(''),
      sIO: new FormControl(''),
      sProfitCenter: new FormControl('', Validators.required),
      sAmountExcludedVAT: new FormControl('', Validators.required),
      sText: new FormControl('', Validators.required),
      IsDelete: new FormControl(false),
      sInvoiceNo: new FormControl('-'),
      nline: new FormControl('')
    }))
    this.checkUseIo();
    this.checkUseGL();

  }
  DeleteInvoice(sInvoiceNo, index) {
    let _this = this;
    let del = function () {
      let invoice = _this.ArrInvoice[index]
      invoice.cActive = "N";
      invoice.IsDelete = true;
      invoice.nLine = (invoice.nLine == null) ? 1 : invoice.nLine;

      _this.CalGrand();
      _this.Checkinvoice();
    }
    this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Delete, del, function () { });
  }
  async EditInvoice(index, save) {
    this.ArrMaster = [];
    this.ArrMaster.push(this.ArrIO);
    let _this = this;
    if (!save) {
      document.getElementById('nVendorCode').scrollIntoView({ behavior: "smooth" });
      this.ArrGL.clear()
      this._paytovendorForm.ArrGL.reset();
      this.nEditindex = index;
      this.isEdit = true;
      let data = this.ArrInvoice[index];
      let arrData = this.ArrInvoice.filter(f => f.sInvoiceNo == data.sInvoiceNo && f.dInvoiceDate == data.dInvoiceDate)
      this.EditInvoiceCode = data.sInvoiceNo;
      this.EditInvoiceDate = data.dInvoiceDate;
      let myDate = data.dInvoiceDate;
      let chunks = myDate.split('/');
      let dInvoiceDate = new Date(chunks[1] + '-' + chunks[0] + '-' + chunks[2]);
      let nVat = '';
      if (this.VatType.filter(s => s.TAX_CODE == data.sVatType).length > 0) {
        nVat = this.VatType.filter(s => s.TAX_CODE == data.sVatType)[0].nVAT;
      }
      this._ArrTumbon = [];
      const httpOptions_Amphur = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sProvCode", data.sProvCode)
      };
      await this.http.get<any>(this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).subscribe(res => {
        if (res) {
          this._ArrAmphur = res;
        }
      });
      const httpOptions_Tumbon = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sAmpCode", data.sAmpCode)
      };
      await this.http.get<any>(this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).subscribe(res => {
        if (res) {
          this._ArrTumbon = res;
        }
      });
      let nWHT = this.WHT.filter(f => f.nWHTID == data.nWHTID)[0];
      let nWHT2 = this.WHT.filter(f => f.nWHTID == data.nWHTID2)[0];
      let ddlWithholdingTax: any;
      let ddlWithholdingTax2: any;

      if (data.nWHTID == null || data.nWHTID == " " || data.nWHTID == "") {
        ddlWithholdingTax = " ";
      }
      if (data.nWHTID2 == null || data.nWHTID2 == " " || data.nWHTID2 == "") {
        ddlWithholdingTax2 = " ";
      }
      if (data.nWHTID == 99) {
        ddlWithholdingTax = 99;
      }
      if (data.nWHTID2 == 99) {
        ddlWithholdingTax2 = 99;
      }
      if (data.nWHTID != null && data.nWHTID != 99 && data.nWHTID != "null") {
        if (nWHT != undefined) ddlWithholdingTax = nWHT.nRate
      }
      if (data.nWHTID2 != null && data.nWHTID2 != 99 && data.nWHTID2 != "null") {
        if (nWHT2 != undefined) ddlWithholdingTax2 = nWHT2.nRate
      }

      let nWHTRate: any;
      let nWHTRate2: any;
      if (data.nWHTID == "0" || data.nWHTID == null) {
        nWHTRate = null;
      } 
      if (data.nWHTID2 == "0" || data.nWHTID2 == null) {
        nWHTRate2 = null;
      } 
      if (data.nWHTID == 99 || data.nWHTID == 6) {
        nWHTRate = data.nWHTRate
      } 
      if (data.nWHTID2 == 99 || data.nWHTID2 == 6) {
        nWHTRate2 = data.nWHTRate2
      } 
      if ((data.nWHTID != "0" || data.nWHTID != null) && data.nWHTID != 99 && data.nWHTID != 6) {
        nWHTRate = null;
      }
      if ((data.nWHTID2 != "0" || data.nWHTID2 != null) && data.nWHTID2 != 99 && data.nWHTID2 != 6) {
        nWHTRate2 = null;
      }
      this.paytovendorForm.patchValue({
        nVendorCode: data.sVendorCode,
        sTAXID: data.sTAXID,
        sVendorName: data.sVendorName,
        cbOffice: data.nOfficeType,
        cbReceiveTypeB2C: data.nReceiveTypeB2C,
        sBranch: data.sVendorBranch,
        sAddress: data.sVendorAddress,
        sCountryID: data.sCountryID,
        sProvCode: data.sProvCode,
        sProvName: data.sProvName,
        sAmpCode: data.sAmpCode,
        sAmpName: data.sAmpName,
        sTumbonCode: data.sTumbonCode,
        sTumbonName: data.sTumbonName,
        sPostCode: data.sPostCode,
        sPhoneNumber: data.sPhoneNumber,
        sFaxNumber: data.sFaxNumber,
        sVendorEmail: data.sVendorEmail,
        sAddressOneTime: data.sAddressOneTime,
        sInvoiceNo: data.sInvoiceNo.startsWith('Blank_20') ? '-' : data.sInvoiceNo,
        dInvoiceDate: dInvoiceDate,
        nTotalAmount: data.sAmount,
        ddCurrency: data.sCurrency,
        nVat: nVat,
        ddVatType: data.sVatType,
        nVatAmount: (!isNullOrUndefined(data.nVAT) ? _this._ConvertToDecimal(data.nVAT) : 0),
        nTotalAmountInvoice: (!isNullOrUndefined(data.nIncludeVAT) ? _this._ConvertToDecimal(data.nIncludeVAT) : 0),
        nTotalAmountVat: (!isNullOrUndefined(data.nExcludeVAT) ? _this._ConvertToDecimal(data.nExcludeVAT) : 0),
        ddlWithholdingTax: ddlWithholdingTax,
        ddlWithholdingTax2: ddlWithholdingTax2,
        nWHTRate: data.nWHTRate == 0 ? " " : data.nWHTRate,
        nWHTRate2: data.nWHTRate2 == 0 ? " " : data.nWHTRate2,
        nWHTOther: nWHTRate,
        nWHTOther2: nWHTRate2,
        nWHTVal: (!isNullOrUndefined(data.nWHTVal) ? _this._ConvertToDecimal(data.nWHTVal) : '0.00'),
        _nWHTVal: (!isNullOrUndefined(data.nWHTVal) ? _this._ConvertToDecimal(data.nWHTVal) : '0.00'),
        nWHTVal2: (!isNullOrUndefined(data.nWHTVal2) ? _this._ConvertToDecimal(data.nWHTVal2) : '0.00'),
        _nWHTVal2: (!isNullOrUndefined(data.nWHTVal2) ? _this._ConvertToDecimal(data.nWHTVal2) : '0.00'),
        nWHTBase: (!isNullOrUndefined(data.nWHTBase) ? _this._ConvertToDecimal(data.nWHTBase) : 0),
        nWHTBase2: (!isNullOrUndefined(data.nWHTBase2) ? _this._ConvertToDecimal(data.nWHTBase2) : 0),
      })
      this.Editsetvat();
      this.onWithholdingTaxSelect(1, false);
      this.onWithholdingTaxSelect(2, false);
      let num = 0;
      arrData.forEach(function (arrGL, i) {
        _this.ArrMaster = [];
        _this.ArrMaster.push(_this.ArrIO);
        _this.ArrGL.push(new FormGroup({
          sGL: new FormControl('', Validators.required),
          sCostCenter: new FormControl(''),
          sIO: new FormControl(''),
          sProfitCenter: new FormControl('', Validators.required),
          sAmountExcludedVAT: new FormControl('', Validators.required),
          sText: new FormControl('', Validators.required),
          IsDelete: new FormControl(''),
          sInvoiceNo: new FormControl('-'),
          nline: new FormControl('')
        }))
        _this.ArrGL.at(num).patchValue({
          sGL: arrGL.sGL,
          sCostCenter: arrGL.sCostCenter,
          sIO: arrGL.sIO === null ? "Not Require IO (N/A)" : arrGL.sIO,
          sProfitCenter: arrGL.sProfitCenter,
          sAmountExcludedVAT: _this._ConvertToDecimal(arrGL.sAmount),
          sText: arrGL.sText,
          IsDelete: arrGL.cActive == "N" ? true : false,
          sInvoiceNo: arrGL.sInvoiceNo.startsWith('Blank_20') ? '-' : arrGL.sInvoiceNo,
          nline: arrGL.nLine
        })
        const httpOptions_IO = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          }),
          params: new HttpParams()
            .set("sCompCode", _this.nComcode)
        };
        //AutocompleteIO
        _this.http.get(_this.System.SiteName + "api/_System/GetIO2", httpOptions_IO).subscribe((data: Response) => {
          _this.DataIO = data;
          if (_this.DataIO != null) {
            _this.ArrIO = _this.DataIO;
            _this.ArrMaster[i] = _this.ArrIO;
          } else {
            _this.ArrMaster[i] = _this.ArrIO;
          }
        })
        num++;
      });
      this.checkUseIo();
      this.checkUseGL();
      this.CalGrand();
      this.paytovendorForm.controls['ddCurrency'].enable();
    }
    if (save) {
      let pass = true;
      if (_IsNullOrEmpty(_this.paytovendorForm.get('sVendorName').value) || _IsNullOrEmpty(_this.paytovendorForm.get('sAddress').value) || _IsNullOrEmpty(_this.paytovendorForm.get('sTAXID').value)) {
        _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.Desc_Specify_AddInvoice, undefined)
        return false;
      }
      let nTotalAmountVat: number = _ParseFloatToZero(this.paytovendorForm.controls['nTotalAmountVat'].value).toFixed(2);
      let nWHTBase: number = _ParseFloatToZero(this.paytovendorForm.controls['nWHTBase'].value).toFixed(2);
      let nWHTBase2: number = _ParseFloatToZero(this.paytovendorForm.controls['nWHTBase2'].value).toFixed(2);
  
      let base = this._ConvertToDecimal((Number(nWHTBase) + Number(nWHTBase2)).toFixed(2));
      let totalAmount = this._ConvertToDecimal((Number(nTotalAmountVat)).toFixed(2));
  
      if (totalAmount !== base && base !== '0.00') {
        _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.Desc_Base_TotalNoMatch, undefined)
        return false;
      }
      let _FormGroup = this.paytovendorForm;
      //    let FieldGLValid: string[] = ["sGL", "sCostCenter", "sIO", "sAmountExcludedVAT"];
      let FieldGLValid: string[];
      //FieldGLValid = ["sCostCenter", "sProfitCenter", "sAmountExcludedVAT", "sText"];
      FieldGLValid = ["sProfitCenter", "sAmountExcludedVAT", "sText"];
      //if (this.isUseIo) {
      //  FieldGLValid.push("sIO");
      //}
      if (this.isUseGL) {
        FieldGLValid.push("sGL");
      }
      for (let i = 0; i < this.ArrGL.length; i++) {
        FieldGLValid.forEach(function (Field) {
          let FromArray = _FormGroup.get('ArrGL') as FormArray;
          if (!FromArray.at(i).get(Field).valid) {
            pass = false;
            return false;
          }
        });
      }
      if (pass) {
        let dInvoiceDate = this.datepipe.transform(this.paytovendorForm.get('dInvoiceDate').value, 'dd/MM/yyyy')
        let InvoiceNo = this.paytovendorForm.get('sInvoiceNo').value;
        let arrGl = this.paytovendorForm.value.ArrGL;
        let arrsum = arrGl.filter(f => f.IsDelete != true).map(m => this.Check2Digit(m.sAmountExcludedVAT));
        let sumNumber = arrsum.reduce((acc, cur) => (acc + cur), 0).toFixed(2);
        let isDup: Boolean;
        let checkDupInvoiceinBase = await this.EditcheckDupinBase(InvoiceNo, dInvoiceDate, this.sReqID)
        isDup = (checkDupInvoiceinBase == "Dup") ? true : false
        if (InvoiceNo === '' || InvoiceNo === '-') isDup = false;
        let tempArr = [];
        this.ArrInvoice.forEach(val => tempArr.push(Object.assign({}, val)));
        while (tempArr.findIndex(e => e.sInvoiceNo === _this.EditInvoiceCode && e.dInvoiceDate === _this.EditInvoiceDate) >= 0)
          tempArr.splice(tempArr.findIndex(f => f.sInvoiceNo === _this.EditInvoiceCode && f.dInvoiceDate === _this.EditInvoiceDate), 1);
        let CheckDupInvoice = tempArr.filter(m =>
          (m.sInvoiceNo == InvoiceNo && m.dInvoiceDate == dInvoiceDate && m.IsDelete == false)
        )
        if (CheckDupInvoice.length == 0 && isDup == false) {
          let _this = this;
          if (sumNumber == Number(_ParseFloatToZero(_this.paytovendorForm.value.nTotalAmountVat).toFixed(2))) {
            let nWHTRate: any;
            let nWHTRate2: any;
            let data = this.ArrInvoice[index];
            arrGl.forEach(function (value, num) {
              let nline = value.nline;
              let arrData = _this.ArrInvoice.filter(f => f.sInvoiceNo == _this.EditInvoiceCode && f.dInvoiceDate == _this.EditInvoiceDate && f.nLine == nline)
              if (arrData.length > 0) {
                arrData.forEach(function (value, i) {
                  value.ntype = _this.paytovendorForm.get('ntype').value;
                  // value.sInvoiceNo = _this.paytovendorForm.get('sInvoiceNo').value === '' ? '-' : _this.paytovendorForm.get('sInvoiceNo').value;
                  if (_this.paytovendorForm.get('sInvoiceNo').value !== '-') {
                    value.sInvoiceNo = _this.paytovendorForm.get('sInvoiceNo').value;
                  }
                  value.sVatType = _this.paytovendorForm.get('ddVatType').value;
                  value.sGL = arrGl[num].sGL;
                  value.sCostCenter = arrGl[num].sCostCenter;
                  value.sIO = arrGl[num].sIO === "Not Require IO (N/A)" ? null : arrGl[num].sIO;
                  value.sProfitCenter = arrGl[num].sProfitCenter;
                  value.sAmount = _ParseFloatToZero(arrGl[num].sAmountExcludedVAT);
                  value.sText = arrGl[num].sText;
                  value.IsDelete = arrGl[num].IsDelete;
                  value.cActive = arrGl[num].IsDelete == true ? 'N' : 'Y';
                  value.nLine = (nline == null) ? 1 : nline;
                  value.nOfficeType = _this.paytovendorForm.get('cbOffice').value;
                  value.nReceiveTypeB2C = _this.paytovendorForm.get('cbReceiveTypeB2C').value;
                  value.sVendorCode = _this.paytovendorForm.get('nVendorCode').value;
                  value.sVendorName = _this.paytovendorForm.get('sVendorName').value;
                  value.sTAXID = _this.paytovendorForm.get('sTAXID').value;
                  value.sVendorBranch = _this.paytovendorForm.get('sBranch').value;
                  value.sVendorAddress = _this.paytovendorForm.get('sAddress').value;
                  value.dInvoiceDate = _this.datepipe.transform(_this.paytovendorForm.get('dInvoiceDate').value, 'dd/MM/yyyy');
                  value.sCurrency = _this.paytovendorForm.get('ddCurrency').value;
                  value.nExcludeVAT = Number(_ParseFloatToZero(_this.paytovendorForm.value.nTotalAmountVat).toFixed(2));
                  value.nVAT = _ParseFloatToZero(_this.paytovendorForm.get('nVatAmount').value);
                  value.nIncludeVAT = _ParseFloatToZero(_this.paytovendorForm.get('nTotalAmountInvoice').value);
                  value.sCountryID = _this.paytovendorForm.get('sCountryID').value
                  value.sProvCode = _this.paytovendorForm.get('sProvCode').value;
                  value.sAmpCode = _this.paytovendorForm.get('sAmpCode').value;
                  value.sTumbonCode = _this.paytovendorForm.get('sTumbonCode').value;
                  value.sPostCode = _this.paytovendorForm.get('sPostCode').value;
                  value.sPhoneNumber = _this.paytovendorForm.get('sPhoneNumber').value;
                  value.sFaxNumber = _this.paytovendorForm.get('sFaxNumber').value;
                  value.sVendorEmail = _this.paytovendorForm.get('sVendorEmail').value;
                  if (_this.paytovendorForm.get('ddlWithholdingTax').value != 0) {

                    nWHTRate = Number(_this.paytovendorForm.get('nWHTRate').value);
                  } else {
                    nWHTRate = Number(_this.paytovendorForm.get('nWHTOther').value);
                  }
                  if (_this.paytovendorForm.get('ddlWithholdingTax2').value != 0) {

                    nWHTRate2 = Number(_this.paytovendorForm.get('nWHTRate2').value);
                  } else {
                    nWHTRate2 = Number(_this.paytovendorForm.get('nWHTOther2').value);
                  }
                  let nWHT = _this.WHT.filter(f => f.nRate == _this.paytovendorForm.get('ddlWithholdingTax').value && _this.paytovendorForm.get('ddlWithholdingTax').value !== ' ')[0];
                  let nWHT2 = _this.WHT.filter(f => f.nRate == _this.paytovendorForm.get('ddlWithholdingTax2').value && _this.paytovendorForm.get('ddlWithholdingTax2').value !== ' ')[0];
                  let nWHTID: any;
                  let nWHTID2: any;
                  if (nWHT == null || nWHT == " " || nWHT == "" || nWHT == undefined) {
                    nWHTID = null;
                    if (_this.paytovendorForm.get('ddlWithholdingTax').value == 99) {
                      nWHTID = 99;
                    }
                  }
                  else {
                    if (_this.paytovendorForm.get('ddlWithholdingTax').value == 99) {
                      nWHTID = 99;
                    } if (nWHT != null) {
                      nWHTID = nWHT.nWHTID;
                    }
                  }
                  if (nWHT2 == null || nWHT2 == " " || nWHT2 == "" || nWHT2 == undefined) {
                    nWHTID2 = null;
                    if (_this.paytovendorForm.get('ddlWithholdingTax2').value == 99) {
                      nWHTID2 = 99;
                    }
                  }
                  else {
                    if (_this.paytovendorForm.get('ddlWithholdingTax2').value == 99) {
                      nWHTID2 = 99;
                    } if (nWHT2 != null) {
                      nWHTID2 = nWHT2.nWHTID;
                    }
                  }

                  //    let nWHTRate: any;
                  if (_this.paytovendorForm.get('ddlWithholdingTax').value == "0" || _this.paytovendorForm.get('ddlWithholdingTax').value == null) {
                    nWHTRate = Number(_this.paytovendorForm.get('nWHTRate').value);
                  } 
                  if (_this.paytovendorForm.get('ddlWithholdingTax2').value == "0" || _this.paytovendorForm.get('ddlWithholdingTax2').value == null) {
                    nWHTRate2 = Number(_this.paytovendorForm.get('nWHTRate2').value);
                  } 
                  if (_this.paytovendorForm.get('ddlWithholdingTax').value == 99 || _this.paytovendorForm.get('ddlWithholdingTax').value == 6) {
                    nWHTRate = Number(_this.paytovendorForm.get('nWHTOther').value);
                  }
                  if (_this.paytovendorForm.get('ddlWithholdingTax2').value == 99 || _this.paytovendorForm.get('ddlWithholdingTax2').value == 6) {
                    nWHTRate2 = Number(_this.paytovendorForm.get('nWHTOther2').value);
                  }
                  value.nWHTID = nWHTID == null ? null : nWHTID;
                  value.nWHTID2 = nWHTID2 == null ? null : nWHTID2;
                  value.nWHTRate = nWHTRate;
                  value.nWHTRate2 = nWHTRate2;
                  value.nWHTVal = _this.paytovendorForm.get('nWHTVal').value;
                  value.nWHTVal2 = _this.paytovendorForm.get('nWHTVal2').value;
                  value.nWHTBase = _this.paytovendorForm.get('nWHTBase').value;
                  value.nWHTBase2 = _this.paytovendorForm.get('nWHTBase2').value;
                })
              } else {
                let nWHT = _this.WHT.filter(f => f.nRate == _this.paytovendorForm.get('ddlWithholdingTax').value && _this.paytovendorForm.get('ddlWithholdingTax').value !== ' ')[0];
                let nWHT2 = _this.WHT.filter(f => f.nRate == _this.paytovendorForm.get('ddlWithholdingTax2').value && _this.paytovendorForm.get('ddlWithholdingTax2').value !== ' ')[0];
                let nWHTID: any;
                let nWHTID2: any;
                if (nWHT == null || nWHT == " " || nWHT == "") {
                  nWHTID = null;
                }
                else {
                  if (_this.paytovendorForm.get('ddlWithholdingTax').value == 99) {
                    nWHTID = 99;
                  } if (nWHT != null) {
                    nWHTID = nWHT.nWHTID;
                  }
                }
                if (nWHT2 == null || nWHT2 == " " || nWHT2 == "") {
                  nWHTID2 = null;
                }
                else {
                  if (_this.paytovendorForm.get('ddlWithholdingTax2').value == 99) {
                    nWHTID2 = 99;
                  } if (nWHT != null) {
                    nWHTID2 = nWHT.nWHTID;
                  }
                }

                if (_this.paytovendorForm.get('ddlWithholdingTax').value != 0) {
                  nWHTRate = Number(_this.paytovendorForm.get('nWHTRate').value);
                } 
                if (_this.paytovendorForm.get('ddlWithholdingTax2').value != 0) {
                  nWHTRate2 = Number(_this.paytovendorForm.get('nWHTRate2').value);
                } 
                if (_this.paytovendorForm.get('ddlWithholdingTax2').value == 99) {
                  nWHTRate2 = Number(_this.paytovendorForm.get('nWHTOther2').value);
                }
                let arr = {
                  // sInvoiceNo: _this.paytovendorForm.get('sInvoiceNo').value === '' ? '-' : _this.paytovendorForm.get('sInvoiceNo').value,
                  sInvoiceNo: _this.paytovendorForm.get('sInvoiceNo').value,
                  sVatType: _this.paytovendorForm.get('ddVatType').value,
                  nLine: _this.ArrInvoice.filter(f => f.sInvoiceNo == data.sInvoiceNo && f.dInvoiceDate == data.dInvoiceDate).length + 1,
                  sGL: arrGl[num].sGL,
                  sCostCenter: arrGl[num].sCostCenter,
                  sIO: arrGl[num].sIO,
                  sProfitCenter: arrGl[num].sProfitCenter,
                  sAmount: _ParseFloatToZero(arrGl[num].sAmountExcludedVAT),
                  sText: arrGl[num].sText,
                  cVenderMaster: "M",
                  cActive: arrGl[num].IsDelete == true ? 'N' : 'Y',
                  ntype: _this.paytovendorForm.get('ntype').value,
                  sVendorCode: _this.paytovendorForm.get('nVendorCode').value,
                  sVendorName: _this.paytovendorForm.get('sVendorName').value,
                  sTAXID: _this.paytovendorForm.get('sTAXID').value,
                  sVendorBranch: _this.paytovendorForm.get('sBranch').value,
                  sVendorAddress: _this.paytovendorForm.get('sAddress').value,
                  dInvoiceDate: _this.datepipe.transform(_this.paytovendorForm.get('dInvoiceDate').value, 'dd/MM/yyyy'),
                  sCurrency: _this.paytovendorForm.get('ddCurrency').value,
                  nExcludeVAT: Number(_ParseFloatToZero(_this.paytovendorForm.value.nTotalAmountVat).toFixed(2)),
                  nVAT: _ParseFloatToZero(_this.paytovendorForm.get('nVatAmount').value),
                  nIncludeVAT: _ParseFloatToZero(_this.paytovendorForm.get('nTotalAmountInvoice').value),
                  nWHTID: nWHTID == null ? null : nWHTID,
                  nWHTID2: nWHTID2 == null ? null : nWHTID2,
                  nWHTRate: _ParseFloatToZero(nWHTRate),
                  nWHTRate2: _ParseFloatToZero(nWHTRate2),
                  nWHTVal: _ParseFloatToZero(_this.paytovendorForm.get('nWHTVal').value),
                  _nWHTVal: _ParseFloatToZero(_this.paytovendorForm.get('nWHTVal').value),
                  nWHTVal2: _ParseFloatToZero(_this.paytovendorForm.get('nWHTVal2').value),
                  _nWHTVal2: _ParseFloatToZero(_this.paytovendorForm.get('nWHTVal2').value),
                  nWHTBase: _ParseFloatToZero(_this.paytovendorForm.get('nWHTBase').value),
                  nWHTBase2: _ParseFloatToZero(_this.paytovendorForm.get('nWHTBase2').value),
                  nOfficeType: _this.paytovendorForm.get('cbOffice').value,
                  nReceiveTypeB2C: _this.paytovendorForm.get('cbReceiveTypeB2C').value,
                  nInvoiceType: null,
                  sCountryID: _this.paytovendorForm.get('sCountryID').value,
                  sProvCode: _this.paytovendorForm.get('sProvCode').value,
                  sAmpCode: _this.paytovendorForm.get('sAmpCode').value,
                  sTumbonCode: _this.paytovendorForm.get('sTumbonCode').value,
                  sPostCode: _this.paytovendorForm.get('sPostCode').value,
                  sPhoneNumber: _this.paytovendorForm.get('sPhoneNumber').value,
                  sFaxNumber: _this.paytovendorForm.get('sFaxNumber').value,
                  sEmail: _this.paytovendorForm.get('sVendorEmail').value,
                  dCreateDate: null,
                  sCreateBy: "",
                  dUpdateDate: null,
                  IsDelete: false,
                }
                _this.ArrInvoice.push(arr);
              }
            })

            this.clearSubinvoice();
            this.CalGrand();
            this.Checkinvoice();
            //#region 2021-01-21 Log Save Invoice
            const options = { headers: { 'Content-Type': 'application/json' } };
            _this.http.post<any>(_this.System.SiteName + "api/_Paytovendor/LogInvoice", JSON.stringify(_this.ArrInvoice), options).subscribe(res => {

            })
            //#endregion
          }
          else {
            this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Invoice_TotalNoMatch, undefined)
            return false;
          }
        } else {
          this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Receipt_Duplicate, undefined)
          return false;
        }
      } else {
        //      let FieldGLValid: string[] = ["sGL", "sCostCenter", "sIO", "sAmountExcludedVAT"];
        let FieldGLValid: string[];
        //FieldGLValid = ["sCostCenter", "sProfitCenter", "sAmountExcludedVAT", "sText"];
        FieldGLValid = ["sProfitCenter", "sAmountExcludedVAT", "sText"];
        //if (this.isUseIo) {
        //  FieldGLValid.push("sIO");
        //}
        if (this.isUseGL) {
          FieldGLValid.push("sGL");
        }
        for (let i = 0; i < this.ArrGL.length; i++) {
          FieldGLValid.forEach(function (Field) {
            let FromArray = _FormGroup.get('ArrGL') as FormArray;
            const control = FromArray.at(i).get(Field);             //{3}
            if (control instanceof FormControl && control.status != "DISABLED") {             //{4}
              control.markAsTouched({ onlySelf: true });
            }
          });
        }
      }
    }
  }
  onApprover1(value) {
    let ckNull = this.paytovendorForm.get('ddApprover1').value;
    let ischeck = this.ArrApprover[0].filter(f => f.name1 == ckNull)[0];
    if (ckNull == "") {
      this.paytovendorForm.patchValue({
        sApprove1: null,
      })
    } else if (this.Approve1NoResult == false && !isNullOrUndefined(ischeck)) {
      this.paytovendorForm.patchValue({
        sApprove1: value.item.nUserID,
      })
    } else if (this.Approve1NoResult == false && isNullOrUndefined(ischeck)) {
      this.paytovendorForm.patchValue({
        ddApprover1: null,
        sApprove1: null,
      })
    }
    if (this.Approve1NoResult == true) {
      this.paytovendorForm.patchValue({
        ddApprover1: null,
        sApprove1: null,
      })
    }
  }
  onApprover2(value) {
    let ckNull = this.paytovendorForm.get('ddApprover2').value;
    let ischeck = this.ArrApprover[1].filter(f => f.name1 == ckNull)[0];
    if (ckNull == "") {
      this.paytovendorForm.patchValue({
        sApprove2: null,
      })
    } else if (this.Approve2NoResult == false && !isNullOrUndefined(ischeck)) {
      this.paytovendorForm.patchValue({
        sApprove2: value.item.nUserID,
      })
    }
    else if (this.Approve2NoResult == false && isNullOrUndefined(ischeck)) {
      this.paytovendorForm.patchValue({
        ddApprover2: null,
        sApprove2: null,
      })
    }
    if (this.Approve2NoResult == true) {
      this.paytovendorForm.patchValue({
        ddApprover2: null,
        sApprove2: null,
      })
    }
  }

  onSubmit() {
  }

  //***********Save*****************

  async Save(mode) {
    //#region CheckValidate
    let _this = this;
    let _FormGroup = this.paytovendorForm;
    let IsValid: boolean = true;
    if (ArrFile.filter(f => f.IsDelete === false).length <= 0 && mode !== 1) {
      IsValid = false;
      const chkFile =  document.getElementById('dv_dvFile');
      chkFile.style.border = '1px solid red';
    }
    let FieldValid: string[] = [];
    if (mode != 3) {
      if (mode == 1) {
        FieldValid = ["sName"];
      }
      if (mode == 2 && this.ArrInvoice.filter(f => f.cActive != 'N').length == 0) {
        FieldValid = ["sName", "dDueDate", "sInvoiceNo", "sVendorName", "sTAXID", "sAddress"
          , "dInvoiceDate", "ddVatType", "nTotalAmountVat", "sDescription", "nVatAmount", "ddApprover2", "ddApprover1", "txtCountryID", "sProvName", "sAmpName", "sTumbonName"];
        //    "sCountryID", "sProvCode", "sAmpCode", "sTumbonCode" , "sPostCode", "sPhoneNumber", "sFaxNumber", "sVendorEmail"
      }
      if (mode == 2 && this.ArrInvoice.filter(f => f.cActive != 'N').length > 0) {
        if (!_this.paytovendorForm.get('IsUploadExcelFile').value && (_IsNullOrEmpty(_this.paytovendorForm.get('sVendorName').value) || _IsNullOrEmpty(_this.paytovendorForm.get('sAddress').value) || _IsNullOrEmpty(_this.paytovendorForm.get('sTAXID').value))) {
          _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.Desc_Specify_AddInvoice, undefined)
          _this.clicked = false;
          return false;
        }
        FieldValid = ["sDescription", "ddApprover2", "ddApprover1"];

        if (!this.paytovendorForm.value.IsUploadExcelFile) {
          FieldValid.push('txtCountryID');
          FieldValid.push('sProvName');
          FieldValid.push('sAmpName');
          FieldValid.push('sTumbonName');
        }
        FieldValid.forEach(function (Field) {
          if (!_FormGroup.get(Field).valid && _FormGroup.get(Field).disabled == false) {
            IsValid = false;
          }
        })
      }
      if (this.ArrInvoice.filter(f => f.cActive != 'N').length == 0) {
        FieldValid.forEach(function (Field) {
          if (!_FormGroup.get(Field).valid && _FormGroup.get(Field).disabled == false) {
            IsValid = false;
          }
        });
        //เช็ค ArrGL
        if (IsValid) {
          if (mode == 2 && this.ArrInvoice.filter(f => f.cActive != 'N').length == 0) {
            IsValid = false;
          }
          //let FieldGLValid: string[] = ["sGL", "sCostCenter", "sIO", "sProfitCenter", "sAmountExcludedVAT", "sText"];
          let FieldGLValid: string[] = ["sGL", "sProfitCenter", "sAmountExcludedVAT", "sText"];
          for (let i = 0; i < this.ArrGL.length; i++) {
            FieldGLValid.forEach(function (Field) {
              let FromArray = _FormGroup.get('ArrGL') as FormArray;
              if (!FromArray.at(i).get(Field).valid && mode != 1) {
                IsValid = false;
                _this.clicked = false;
                return false;
              }
            });
          }
        }
      }
      let arrinvoice = _this.ArrInvoice.filter(f => f.IsDelete == false && f.cActive != 'N')
      let arrsum = arrinvoice.map(m => _this.Check2Digit(m.sAmount));
      let arrsumm = [];
      let sumNumber = arrsum.reduce((acc, cur) => (acc + cur), 0).toFixed(2);
      let GroupByinvoice = [];


      _this.ArrInvoice.filter(f => f.IsDelete == false && f.cActive != 'N').forEach(function (value, i) {
        // GroupByinvoice[value.sInvoiceNo] = GroupByinvoice[value.sInvoiceNo] || [];
        let obj = {
          invoice: value.sInvoiceNo,
          InvoiceDate: value.dInvoiceDate
        }
        let ckhave = GroupByinvoice.filter(f => f.invoice == obj.invoice && f.InvoiceDate == obj.InvoiceDate);
        if (ckhave.length == 0) {
          GroupByinvoice.push(obj)
        }

      });
      GroupByinvoice.forEach(function (value, i) {
        let Get_nExcludeVAT = _this.ArrInvoice.filter(f => f.sInvoiceNo == value.invoice && f.dInvoiceDate == value.InvoiceDate && f.IsDelete == false && f.cActive != 'N');
        if (Get_nExcludeVAT.length > 0) {
          arrsumm.push(_this.Check2Digit(Get_nExcludeVAT[0].nExcludeVAT));
        }
      })
      GroupByinvoice.forEach(async function (value, i) {
        let ck = _this.ArrInvoice.filter(f => f.sInvoiceNo == value.invoice && f.dInvoiceDate == value.InvoiceDate)[0];
        let result = await _this.EditcheckDupinBase(ck.sInvoiceNo, ck.dInvoiceDate, _this.paytovendorForm.get('sRequestID').value);
        // if (ck.sInvoiceNo === '' || ck.sInvoiceNo === '-') result = ''; 
        if (result == "Dup") {
          _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.Desc_Receipt_Duplicate, undefined)
          _this.clicked = false;
          return false;
        }
      })
      let sumExclude = arrsumm.reduce((acc, cur) => (acc + cur), 0).toFixed(2)
      if (sumExclude < 0) {
        this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Error_Negative_Value, undefined)
        _this.clicked = false;
        return false;
      }
      else if ((sumNumber == sumExclude) || this.paytovendorForm.get("IsUploadExcelFile").value) {
        //#endregion
        if (IsValid) {
          let arr = _this.ArrInvoice;
          let arrExcel = [];
          let sDocHeader = null;
          for (var i = 0; i < arr.length; i++) {
            if (!sDocHeader) sDocHeader = arr[i].sDocHeader;
            let WHTVal = arr[i].nWHTVal;
            let WHTVal2 = arr[i].nWHTVal2;
            let WHTBase = arr[i].nWHTBase;
            let WHTBase2 = arr[i].nWHTBase2;
            if (WHTVal) {
              if(typeof WHTVal === 'string'){
                arr[i].nWHTVal = _ParseFloatToZero(WHTVal);
              }
            }
            if (WHTVal2) {
              if(typeof WHTVal2 === 'string'){
                arr[i].nWHTVal2 = _ParseFloatToZero(WHTVal2);
              }
            }
            if (WHTBase) {
              if(typeof WHTBase === 'string'){
                arr[i].nWHTBase = _ParseFloatToZero(WHTBase);
              }
            }
            if (WHTBase2) {
              if(typeof WHTBase2 === 'string'){
                arr[i].nWHTBase2 = _ParseFloatToZero(WHTBase2);
              }
            }
          }
          _this.arrExcel.forEach(function (value, i: number) {
            let arr = {
              ...value,
              sInvoiceDate: _this.datepipe.transform(value.sInvoiceDate, "dd/MM/yyyy"),
              sPostingDate: _this.datepipe.transform(value.sPostingDate, "dd/MM/yyyy"),
              sDueDate: (typeof value.sDueDate === 'string') ? value.sDueDate : _this.datepipe.transform(value.sDueDate, "dd/MM/yyyy"),
            };
            arrExcel.push(arr);
          });
          let DataSave = {
            TRequest: {
              sRequestID: _this.paytovendorForm.get('sRequestID').value,
              //sRequestCode: this.getReqID(),
              sCompCode: _this.nComcode,
              nReqType: _this.paytovendorForm.get('ntype').value + "",
              nYear: _this.datepipe.transform(_this.today, 'yyyy'),
              sRequestBy: _this.paytovendorForm.get('sRequestBy').value + "",
              dRequestDate: _this.dToday,
              nContactID: Number(_this.paytovendorForm.get('nContactID').value),
              sContactName: _this.paytovendorForm.get('sName').value,
              dDueDate: _this.datepipe.transform(_this.paytovendorForm.get('dDueDate').value, 'dd/MM/yyyy'),
              dPostingDate: _this.paytovendorForm.get('IsUploadExcelFile').value && _this.sPostingDate ? 
                _this.convertTodate2(_this.sPostingDate) : null,
              sDescription: _this.paytovendorForm.get('sDescription').value,
              sOtherRefNoFIDocNo: _this.paytovendorForm.get('sOtherRefNoFIDocNo').value,
              sUnitName: _this.paytovendorForm.get('sUnit').value,
              sEmail: _this.paytovendorForm.get('sEmail').value,
              sTel: _this.paytovendorForm.get('sTel').value,
              nInvoiceType: "",
              sRefAdvanceNo: "",
              IsReqUrgent: _this.IsReqUrgent,
              IsSSCUrgent: false,
              IsVendorGroup: false,
              sVendorCode: _this.paytovendorForm.get('nVendorCode').value,
              sCurrency: _this.paytovendorForm.get('ddCurrency').value,
              nStatusID: (mode == 1) ? 1 : 2,
              sCopyReqID: _this.paytovendorForm.get('nCopyRequest').value,
              nStep: 1,
              nFlowNo: 1,
              nGrandTotalAmt: _ParseFloatToZero(_this.paytovendorForm.get('GtotalAmountExcluded').value),
              nGrandTotalAmtVat: _ParseFloatToZero(_this.paytovendorForm.get('GtotalVAT').value),
              nGrandTotalWithholdingTax: _ParseFloatToZero(_this.paytovendorForm.get('GtotalWithholdingTax').value),
              nGrandTotalAmtInvoice: _ParseFloatToZero(_this.paytovendorForm.get('GtotalAmountOfInvoice').value),
              sCreateBy: _this.paytovendorForm.get('sRequestBy').value + "",
              sUpdateBy: _this.paytovendorForm.get('sRequestBy').value + "",
              sDeleteBy: "",
              cSkipApprove1: _this.paytovendorForm.get('cSkipApprove1').value == 1 ? "Y" : "N",
              nApprove1: _this.paytovendorForm.get('sApprove1').value,
              cApprove1: "W",
              nApprove2: _this.paytovendorForm.get('sApprove2').value,
              cApprove2: "W",
              cSkipApprove2: "N",
              sBusinessArea: _this.paytovendorForm.get('sBusinessArea').value,
              nReqUrgentDay: _this.nReqUrgentDay,
              dStartDate: _this.Settodate,
              nReceiveTypeB2C: _this.paytovendorForm.get('cbReceiveTypeB2C').value,
              sComment: _this.paytovendorForm.get('sComment').value,
              sCommentSSC: _this.paytovendorForm.get('sCommentSSC').value,
              IsUploadExcelFile: _this.paytovendorForm.get("IsUploadExcelFile").value,
              sDocHeader: sDocHeader
            },
            TRequestItems: arr,
            TRequestExcel: arrExcel,
            FileUp: ArrFile,
            FileExcel: _this.fileExcel,
            CommentDelete: this.sComment,
          }
          let Data = JSON.stringify(DataSave)
          let saveDaft = function () {
            _this.System.BlockUI();
            _this.isEditFromhome = false;
            const headers = new HttpHeaders({
              'Content-Type': 'application/json'
            });
            _this.http.post(_this.System.SiteName + "api/_Paytovendor/Save", Data, { headers, responseType: 'text' }).subscribe(s => {
              if (s == "Success") {
                ArrFile = [];
                _this.System.UnBlockUI();
                _this.SW.SwAlert.Success(_this.SW.BoxMsg.Title_Success, _this.SW.BoxMsg.Desc_SaveComplete, function () { _this.router.navigate(["home"]) });
              } else {
                _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, s, undefined)
                _this.System.UnBlockUI();
              }
            });
          }
          this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Submit, saveDaft, function () { });
        } else {
          FieldValid.forEach(function (Field) {
            const control = _FormGroup.get(Field);
            //{3}
            if (control instanceof FormControl && control.status != "DISABLED") {             //{4}
              control.markAsTouched({ onlySelf: true });
            }
          });
        }
        if (this.ArrInvoice.filter(f => f.cActive != 'N').length == 0) {
          //let FieldGLValid: string[] = ["sGL", "sCostCenter", "sIO", "sProfitCenter", "sAmountExcludedVAT", "sText"];
          let FieldGLValid: string[] = ["sGL", "sProfitCenter", "sAmountExcludedVAT", "sText"];
          for (let i = 0; i < this.ArrGL.length; i++) {
            FieldGLValid.forEach(function (Field) {
              let FromArray = _FormGroup.get('ArrGL') as FormArray;
              const control = FromArray.at(i).get(Field);             //{3}
              if (control instanceof FormControl && mode != 1 && control.status != "DISABLED") {             //{4}
                control.markAsTouched({ onlySelf: true });
              }
            });
          }
        }
      }
      else {
        this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Invoice_TotalNoMatch, undefined)
        _this.clicked = false;
        return false;
      }
    }
    //Recall
    if (mode == 3) {
      let DataSave = {
        TRequest: {
          sRequestID: _this.paytovendorForm.value.sRequestID,
          nStatusID: 3,
        }
      }
      let Data = JSON.stringify(DataSave)
      let SaveRecall = function () {
        _this.isEditFromhome = false;
        const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });
        _this.http.post(_this.System.SiteName + "api/_Paytovendor/Recall", Data, { headers, responseType: 'text' }).subscribe(s => {
          if (s == "Success") {
            _this.SW.SwAlert.Success(_this.SW.BoxMsg.Title_Success, _this.SW.BoxMsg.Desc_SaveComplete, function () { _this.router.navigate(["home"]) });
          }
        })
      }
      this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Save, SaveRecall, function () { });
    }
    _this.clicked = false;
  }
  cancel() {
    let _this = this;
    if (_this.sComment === null || _this.sComment === "") {
      this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Specify_Comment, undefined)
    }
    else {
      let DataSave = {
        TRequest: {
          sRequestID: _this.paytovendorForm.value.sRequestID,
          nStatusID: 0,
        },
        CommentDelete: this.sComment,
      }
      let Data = JSON.stringify(DataSave)
      let SaveRecall = function () {
        const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });
        _this.http.post(_this.System.SiteName + "api/_Paytovendor/cancel", Data, { headers, responseType: 'text' }).subscribe(s => {
          if (s == "Success") {
            _this.SW.SwAlert.Success(_this.SW.BoxMsg.Title_Success, _this.SW.BoxMsg.Desc_Success_Delete, function () { _this.router.navigate(["home"]) });
          }
        })
      }
      this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Delete, SaveRecall, function () { });
    }
  }

  //***********EditFormHome*****************

  async Edit(sReqID) {
    let _this = this;
    this.System.BlockUI();
    let Isnull = sReqID == "" ? true : false;
    const ua = this.System.GetUserStorage();
    if(this.isForROS) Isnull = true;
    if (ua.IsROService && Isnull) {
      this.isReject = true;
    }
    if (!Isnull) { // เช็คว่า ใบใหม่หรือใบเก่า
      _this.paytovendorForm.patchValue({ sRequestID: sReqID });
      _this.isDraft = true;
      _this.isPrint = true;
      _this.haveComments = true;
      await this.http.get(this.System.SiteName + "api/Autocomplete/TRequest/sRequestCode/sRequestID/" + sReqID + "").toPromise().then(Data => {
        if (Data) {
          if (!isNullOrUndefined(Data[0].sRequestCode) && Data[0].sRequestCode != "") {
            _this.sReqCode = Data[0].sRequestCode;
            _this.haveRequestCode = true;
          }
        }
      })
      //await this.http.get(this.System.SiteName + "api/_Paytovendor/CheckReject/" + sReqID + "").toPromise().then(Data => {
      //  if (Data) {
      //    if (!isNullOrUndefined(Data[0].sComment) && Data[0].sComment != "") {
      //      _this.sComment = Data[0].sComment;
      //      _this.paytovendorForm.patchValue({
      //        sComment: Data[0].sComment,
      //      })
      //    }
      //  }
      //})
      let _FormGroup = this.paytovendorForm;
      this.ArrMaster = [];
      this.ArrMaster.push(this.ArrIO);
      this.ArrGL.clear()
      this._paytovendorForm.ArrGL.reset();
      let data: any;
      let data2: any;
      await this.http.get(this.System.SiteName + "api/_Paytovendor/GetRequest/" + sReqID + "").toPromise().then(Data => data = Data)
      _this.ArrInvoice = data;
      await this.http.get(this.System.SiteName + "api/_Paytovendor/GetTransactionHistory/" + sReqID + "").toPromise().then(Data => data2 = Data)
      _this.ArrTransactionHistory = data2;
      if (_this.ArrInvoice != null) {
        _this.Checkinvoice();
        _this.ArrInvoice.forEach(function (value, i) {
          _this.paytovendorForm.patchValue({
            ntype: value.ntype,
            sComment: value.sComment,
            sCommentSSC: value.sCommentSSC,
          })
          _this.onTypeSelect(value.ntype.toString(), value.ntype === 71);
          _this.sComment = value.sComment;
          _this.sCommentSSC = value.sCommentSSC;
        
        })
      }
      let lstArrInvoice = _this.ArrInvoice != null ? _this.ArrInvoice.filter(f => f.cActive != 'N') : [];
      if (lstArrInvoice.length > 0) { // เช็คว่า มี invoice ไหม

        if (lstArrInvoice[0].nStatusID == 1 || lstArrInvoice[0].nStatusID == 3 || lstArrInvoice[0].nStatusID == 5 || lstArrInvoice[0].nStatusID == 7 || lstArrInvoice[0].nStatusID == 10) {
          let chunks = lstArrInvoice[0].dDueDate.split('/');
          this.toDay = lstArrInvoice[0].dRequestDate == null ? this.BusinessDay.SetToday(this.holidays) : new Date(lstArrInvoice[0].dRequestDate);
          let dDuedate = new Date(chunks[1] + '-' + chunks[0] + '-' + chunks[2]);

          if ((lstArrInvoice[0].nStatusID == 1 || lstArrInvoice[0].nStatusID == 3 || lstArrInvoice[0].nStatusID == 5 || lstArrInvoice[0].nStatusID == 7 || lstArrInvoice[0].nStatusID == 10) && dDuedate < _this.Settodate) {
            this.maxDate.setDate(this.maxDate.getDate() + 1)
            this.TODAY = this.BusinessDay.SetNextDate(this.maxDate, this.holidays);
          }
          await _this.http.get(_this.System.SiteName + "api/_paytovendor/GetRequest/" + lstArrInvoice[0].sCopyReqID + "").toPromise().then((data: any) => {
            if (data != null) {
              let Data = data.filter(f => f.cActive != 'N');
              _this.paytovendorForm.patchValue({
                sCopyRequest: Data[0].sRequestCode,
              })
            }
          })

          let isOntime: any;
          if (lstArrInvoice[0].sVendorCode != null) {

            if (lstArrInvoice[0].IsVendorOneTime) {
              isOntime = true;
            } else {
              isOntime = false;
            }
          }
          await this.onTypeSelect(lstArrInvoice[0].sVendorCode, isOntime);
          _this.isEditFromhome = true;
          const httpOptions_Amphur = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json'
            }),
            params: new HttpParams()
              .set("sProvCode", lstArrInvoice[0].sProvCode)
          };
          await _this.http.get<any>(_this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).toPromise().then(res => {
            if (res) {
              _this._ArrAmphur = res;
            }
          });
          const httpOptions_Tumbon = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json'
            }),
            params: new HttpParams()
              .set("sAmpCode", lstArrInvoice[0].sAmpCode)
          };
          await _this.http.get<any>(_this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).toPromise().then(res => {
            if (res) {
              _this._ArrTumbon = res;
            }
          });
          let Amp = this._ArrAmphur.filter(f => f.sAmpCode == lstArrInvoice[0].sAmpCode)[0];
          let Country = this._ArrCountry.filter(f => f.sCountryID == lstArrInvoice[0].sCountryID)[0];
          let prov = this._ArrProvince.filter(f => f.sProvCode == lstArrInvoice[0].sProvCode)[0];
          let tumbon = this._ArrTumbon.filter(f => f.sTumbonCode == lstArrInvoice[0].sTumbonCode)[0];
          this.hBranch = lstArrInvoice[0].nOfficeType == 2 ? false : true;

          if (this.hBranch == false) {
            this.paytovendorForm.controls['sBranch'].enable();
            this.paytovendorForm.patchValue({
              sBranch: lstArrInvoice[0].sVendorBranch,
              cbOffice: lstArrInvoice[0].nOfficeType,
            })
            if (this.ArrInvoice.filter(f => f.cActive != 'N').length > 0) {
              this.ArrInvoice.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
                invoice.cbOffice = _this.paytovendorForm.value.cbOffice == 1 ? 1 : lstArrInvoice[0].cbOffice;
                invoice.nOfficeType = _this.paytovendorForm.value.cbOffice == 1 ? 1 : _this.paytovendorForm.value.cbOffice;
                invoice.sVendorBranch = lstArrInvoice[0].sVendorBranch;
              })
            }
          } else {
            this.paytovendorForm.controls['sBranch'].disable();
            this.paytovendorForm.patchValue({
              sBranch: "",
              cbOffice: lstArrInvoice[0].nOfficeType,
            })
            if (this.ArrInvoice.filter(f => f.cActive != 'N').length > 0) {
              this.ArrInvoice.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
                invoice.cbOffice = _this.paytovendorForm.value.cbOffice == 1 ? 1 : lstArrInvoice[0].cbOffice;
                invoice.nOfficeType = _this.paytovendorForm.value.cbOffice == 1 ? 1 : _this.paytovendorForm.value.cbOffice;
                invoice.sVendorBranch = "";
              })
            }
          }

          _this.ArrInvoice.forEach(function (value, i) {
            _this.Currencys = value.sCurrency;
            _this.IsVendorOneTime = value.IsVendorOneTime;
            _this.isDraft = (value.nStatusID == 1 || value.nStatusID == 3 || value.nStatusID == 5 || value.nStatusID == 7 || value.nStatusID == 10 ? true : false);
            _this.isSubmit = (value.nStatusID == 2 ? true : false);
            _this.isNew = true;
            _this.isPrint = true;
            _this.isThai = true;
            value.IsDelete = value.cActive == 'N' ? true : false;
            if (value.cSkipApprove1 == "Y") {
              _this.paytovendorForm.get('ddApprover1').disable()
            } else {
              _this.paytovendorForm.get('ddApprover1').enable();
            }

            _this.paytovendorForm.patchValue({
              nContactID: value.nContactID + "",
              sName: value.sName,
              sEmail: value.sEmail,
              sUnit: value.sUnit,
              sTel: value.sTel,
              ntype: value.ntype,
              dDueDate: new Date(_this.convertTodate(value.dDueDate)),
              cbOffice: isNullOrUndefined(value.nOfficeType) == true ? 1 : value.nOfficeType,
              cbReceiveTypeB2C: value.nReceiveTypeB2C,
              nCopyRequest: value.sCo3pyReqID,
              sDescription: value.sDescription,
              sOtherRefNoFIDocNo: value.sOtherRefNoFIDocNo,
              nVendorCode: value.sVendorCode,
              sVendorName: value.sVendorName,
              sTAXID: value.sTAXID,
              sBranch: value.sVendorBranch,
              sAddress: value.sVendorAddress,
              sCountryID: value.sCountryID,
              txtCountryID: isNullOrUndefined(Country) == true ? "" : Country.sCountryName,
              sProvCode: value.sProvCode,
              // sProvName: isNullOrUndefined(prov) == true ? "" : prov.sProvname,
              sProvName: value.sProvName,
              sAmpCode: value.sAmpCode,
              //sAmpName: isNullOrUndefined(Amp) == true ? "" : Amp.sAmpName,
              sAmpName: value.sAmpName,
              sTumbonCode: value.sTumbonCode,
              //sTumbonName: isNullOrUndefined(tumbon) == true ? "" : tumbon.sTumbonName,
              sTumbonName: value.sTumbonName,
              sPostCode: value.sPostCode,
              sPhoneNumber: value.sPhoneNumber,
              sFaxNumber: value.sFaxNumber,
              sVendorEmail: value.sVendorEmail,
              sRequestID: value.sRequestID,
              ddApprover1: value.sUserApprove1,
              ddApprover2: value.sUserApprove2,
              sApprove1: value.nApprove1 == null ? null : value.nApprove1,
              sApprove2: value.nApprove2 == null ? null : value.nApprove2,
              cSkipApprove1: value.cSkipApprove1 == "Y" ? true : false,
              GtotalAmountExcluded: _ParseFloatToZero(value.nGrandTotalAmt),
              GtotalVAT: _ParseFloatToZero(value.nGrandTotalAmtVat),
              GtotalWithholdingTax: _ParseFloatToZero(value.nGrandTotalWithholdingTax),
              GtotalAmountOfInvoice: _ParseFloatToZero(value.nGrandTotalAmtInvoice),
              ddCurrency: value.sCurrency,
              sComment: value.sComment,
              sCommentSSC: value.sCommentSSC,
              IsUploadExcelFile: value.IsUploadExcelFile
              ? value.IsUploadExcelFile
              : false,
            })

            _this.sCommentSSC = value.sCommentSSC;
          })
        }
        if (this.paytovendorForm.get("IsUploadExcelFile").value == true) {
          let data: any;
          await this.http
            .get(
              this.System.SiteName +
                "api/_Paytovendor/GetRequestExcel/" +
                sReqID +
                ""
            )
            .toPromise()
            .then((Data) => (data = Data));

          for (var i = 0; i < data.length; i++) {
            let chunks1 = data[i].dInvoiceDate.split("/");
            let chunks2 = data[i].dPostingDate.split("/");
            let chunks3 = data[i].dDueDate.split("/");
            var dInvoiceDate = new Date(chunks1[2], chunks1[1] - 1, chunks1[0]);
            var dPostingDate = new Date(chunks2[2], chunks2[1] - 1, chunks2[0]);
            var dDueDate = new Date(chunks3[2], chunks3[1] - 1, chunks3[0]);
            data[i].sNo = (i + 1).toString();;
            data[i].dInvoiceDate = dInvoiceDate;
            data[i].dPostingDate = dPostingDate;
            data[i].dDueDate = dDueDate;
          }
          _this.arrExcel = data;
        }
        _this.ArrGL.push(new FormGroup({
          sGL: new FormControl('', Validators.required),
          sCostCenter: new FormControl(''),
          sIO: new FormControl(''),
          sProfitCenter: new FormControl('', Validators.required),
          sAmountExcludedVAT: new FormControl('', Validators.required),
          sText: new FormControl('', Validators.required),
          IsDelete: new FormControl(''),
          sInvoiceNo: new FormControl('-'),
          nline: new FormControl('')
        }))
        this.checkUseIo();
        this.checkUseGL();
        this.System.UnBlockUI();
      } else {
        this.ArrMaster = [];
        this.ArrMaster.push(this.ArrIO);
        this.ArrGL.clear();
        this.Currencys = "THB";
        _this.paytovendorForm.patchValue({
          GtotalVAT: 0,
          GtotalAmountExcluded: 0,
          GtotalAmountOfInvoice: 0,
          GtotalWithholdingTax: 0,
        });
        this._paytovendorForm.ArrGL.reset();
        _this.ArrGL.push(new FormGroup({
          sGL: new FormControl('', Validators.required),
          sCostCenter: new FormControl(''),
          sIO: new FormControl(''),
          sProfitCenter: new FormControl('', Validators.required),
          sAmountExcludedVAT: new FormControl('', Validators.required),
          sText: new FormControl('', Validators.required),
          IsDelete: new FormControl(''),
          sInvoiceNo: new FormControl('-'),
          nline: new FormControl('')
        }))
        _this.isNew = true;
        _this.ArrInvoice = [];
        this.checkUseIo();
        this.checkUseGL();
        let data: any;
        await this.http.get(this.System.SiteName + "api/_Paytovendor/GetRequestNoItem/" + sReqID + "").toPromise().then(Data => data = Data)
        if (data != null) {
          let chunks = data[0].dDueDate.split('/');
          this.toDay = data[0].dRequestDate == null ? this.BusinessDay.SetToday(this.holidays) : new Date(data[0].dRequestDate);
          let dDuedate = new Date(chunks[1] + '-' + chunks[0] + '-' + chunks[2]);
          //       let check_date = this.BusinessDay.SetDueDate(dDuedate, this.holidays);
          if ((data[0].nStatusID == 1 || data[0].nStatusID == 3 || data[0].nStatusID == 5 || data[0].nStatusID == 7 || data[0].nStatusID == 10) && dDuedate < _this.Settodate) {
            this.maxDate.setDate(this.maxDate.getDate() + 1)
            this.TODAY = this.BusinessDay.SetNextDate(this.maxDate, this.holidays);
          }
          if (data[0].cSkipApprove1 == "Y") {
            _this.paytovendorForm.get('ddApprover1').disable()
          } else {
            _this.paytovendorForm.get('ddApprover1').enable();
          }
          _this.paytovendorForm.patchValue({
            dDueDate: dDuedate,
            nContactID: data[0].nContactID + "",
            sName: data[0].sName,
            sEmail: data[0].sEmail,
            sUnit: data[0].sUnit,
            sTel: data[0].sTel,
            ntype: data[0].ntype,

            sRequestID: data[0].sRequestID,
            ddApprover1: data[0].sUserApprove1,
            ddApprover2: data[0].sUserApprove2,
            sApprove1: data[0].nApprove1 == null ? null : data[0].nApprove1,
            sApprove2: data[0].nApprove2 == null ? null : data[0].nApprove2,
            cSkipApprove1: data[0].cSkipApprove1 == "Y" ? true : false,

          });
       
        }
        this.System.UnBlockUI();
      }
    } else {
      this.Currencys = "THB";
      if (!this.isNewRequest) {
        let data: any;
        await _this.http.get(_this.System.SiteName + "api/ROService/GetRequest/" + sReqID + "").toPromise().then(Data => data = Data)
        if(data != null){
          _this.paytovendorForm.patchValue({
            sRequestID: data[0].sRequestID,
            ntype: data[0].nReqType.toString(),
            sComment: data[0].sComment,
            sCommentSSC: `Expected Complete Date : ${data[0].dExpectedCompleteDate}${data[0].sRemarkSSC ? `\n${data[0].sRemarkSSC}` : ''}`,
          });
          _this.sComment = data[0].sComment;
          _this.sCommentSSC = data[0].sRemarkSSC;
          _this.onTypeSelect(data[0].nReqType.toString(), false);
          _this.onUserSelect(data[0].sFullName);
        }
      }
     
      _this.paytovendorForm.patchValue({
        GtotalVAT: 0,
        GtotalAmountExcluded: 0,
        GtotalAmountOfInvoice: 0,
        GtotalWithholdingTax: 0,
      });
    }
    
    if (!this.isNewRequest) {
      let file: any;
      await this.http.get(this.System.SiteName + "api/_Paytovendor/Getfile/" + sReqID + "").toPromise().then(Data => file = Data);
      if (file) {
        let arrdata = [];
        if (file.length != 0) {
          file.forEach(f => arrdata.push({
            nID: f.nFileOrder,
            sPath: f.sPathFile,
            sSystemFileName: f.sSystemFileName,
            sFileName: f.sFileName,
            sSize: +f.sFileSize,
          }))
          SetData('dvFile', arrdata)
        }
      }
    }
   
    //Check Permission
    let ObjData = {
      sRequestID: sReqID,
      nMenuID: 10
    }
    let isio = await this.System.GetCompanyUSEIO(ObjData);
    if (isio != null) {
      _this.isUseIo = isio;
      _this.IsNotFill_IO = isio;
      _this.checkUseIo();
    }
    let isGL = await this.System.GetCompanyUSEGL(ObjData);
    if (isGL != null) {
      _this.isUseGL = isGL;
      _this.IsNotFill_GL = isGL;
      _this.checkUseGL();
    }
    this.ResultPermission = await this.System.CheckPermission(ObjData);
    if (!this.ResultPermission) {
      this.paytovendorForm.disable();
      this.paytovendorForm.get('GtotalVAT').enable();
      this.paytovendorForm.get('GtotalAmountExcluded').enable();
      this.paytovendorForm.get('GtotalAmountOfInvoice').enable();
      this.paytovendorForm.get('GtotalWithholdingTax').enable();
      this.paytovendorForm.get('sCompName').enable();
    }

    this.System.UnBlockUI();
  }

  //*****************************************
  OnBlurGCI(event: TypeaheadMatch, _inx, _sType) {
    let FromArray = this.paytovendorForm.get('ArrGL') as FormArray;
    let Pass: boolean = true;
    try {
      switch (_sType) {
        case "G":
          if (!event.item.GL_ACCOUNT_NO) {
            Pass = false;
          }
          break;
        case "C":
          let stC = this.ArrGL.at(_inx).get('sCostCenter').value;
          let ischeckC = this.ArrCostCenter.filter(f => f.COST_CENTER == stC || f.name == stC || f.DESCRIPTION == stC)[0];
          if (isNullOrUndefined(ischeckC)) {
            Pass = false;
          }
          break;
        case "I":
          let stI = this.ArrGL.at(_inx).get('sIO').value;
          let ischeckI = this.ArrMaster[_inx].filter(f => f.ORDER_NUMBER == stI || f.name == stI || f.DESCRIPTION == stI)[0];
          if (isNullOrUndefined(ischeckI)) {
            Pass = false;
          }
          break;
        case "P":
          let stP = this.ArrGL.at(_inx).get('sProfitCenter').value;
          let ischeckP = this.ArrProfitCenter.filter(f => f.sProfitCenterNo == stP || f.name == stP || f.DESCRIPTION == stP)[0];
          if (isNullOrUndefined(ischeckP)) {
            Pass = false;
          }
          break;
      }
    }
    catch (ex) {//กรณีที่พังจะ Reset ค่าทิ้ง
      Pass = false;
    }
    if (Pass) {
      this.OnSelectGCI(event, _inx, _sType)
    }
    else {
      switch (_sType) {
        case "G":
          FromArray.at(_inx).patchValue({ sGL: "" });
          break;
        case "C":
          FromArray.at(_inx).patchValue({ sCostCenter: "" });
          break;
        case "I":
          FromArray.at(_inx).patchValue({ sIO: "" });
          break;
        case "P":
          FromArray.at(_inx).patchValue({ sProfitCenter: "" });
          break;
      }
    }
  }
  OnSelectGCI(event, _inx, _sType) {
    let FromArray = this.paytovendorForm.get('ArrGL') as FormArray;
    switch (_sType) {
      case "G":
        FromArray.at(_inx).patchValue({ sGL: event.item.GL_ACCOUNT_NO });
        break;
      case "C":
        this.ArrMaster[_inx] = this.ArrIO;
        FromArray.at(_inx).patchValue({ sCostCenter: event.item.COST_CENTER });
        break;
      case "I":
        FromArray.at(_inx).patchValue({ sIO: event.item.ORDER_NUMBER });
        break;
      case "P":
        FromArray.at(_inx).patchValue({ sProfitCenter: event.item.sProfitCenterNo });
        break;
    }
  }

  AddGL() {
    this.ArrMaster.push(this.ArrIO);
    this.ArrGL.push(new FormGroup({
      sGL: new FormControl('', Validators.required),
      sCostCenter: new FormControl(''),
      sIO: new FormControl(''),
      sProfitCenter: new FormControl('', Validators.required),
      sAmountExcludedVAT: new FormControl('', Validators.required),
      sText: new FormControl('', Validators.required),
      IsDelete: new FormControl(false),
      sInvoiceNo: new FormControl('-')
    }));
    this.checkUseIo()
  }
  DeleteGL(sInvoiceNo, row) {

    let _this = this;

    this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Delete, function () {
      _this.ArrGL.at(row).patchValue({ IsDelete: true });
      let isnull = !isNullOrUndefined(sInvoiceNo) ? sInvoiceNo : "";
      if (isnull == "") {
        _this.ArrGL.removeAt(row);
      } else {
        let data = _this.ArrInvoice.filter(f => f.sInvoiceNo == sInvoiceNo)[row];
        if (data) {
          data.IsDelete = true;
        }
        //  let FromArray = _this.paytovendorForm.get('ArrGL') as FormArray;
        //let FieldGLValid: string[] = ['sGL', 'sCostCenter', 'sIO', 'sAmountExcludedVAT', 'sText'];
        let FieldGLValid: string[] = ['sGL', 'sAmountExcludedVAT', 'sText'];
        for (let i = 0; i < FieldGLValid.length; i++) {

          _this.ArrGL.at(row).get(FieldGLValid[i]).clearValidators();
          _this.ArrGL.at(row).get(FieldGLValid[i]).setValidators([]);
          _this.ArrGL.at(row).get(FieldGLValid[i]).updateValueAndValidity();
        }
      }
      // _this.Checkinvoice();
    }, function () { });
  }
  hidBranch() {
    let _this = this;
    this.hBranch = this.paytovendorForm.value.cbOffice == 2 ? false : true;
    if (this.hBranch == false) {
      var code = this.paytovendorForm.get('sBranch').value;
      if (code === '') code = '00000'
      this.paytovendorForm.controls['sBranch'].enable();
      this.paytovendorForm.patchValue({ sBranch: code })
      if (this.ArrInvoice.filter(f => f.cActive != 'N').length > 0) {
        this.ArrInvoice.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          invoice.cbOffice = _this.paytovendorForm.value.cbOffice == 1 ? 1 : _this.paytovendorForm.value.cbOffice;
          invoice.nOfficeType = _this.paytovendorForm.value.cbOffice == 1 ? 1 : _this.paytovendorForm.value.cbOffice;
          invoice.sVendorBranch = code;
        })
      }
    } else {
      this.paytovendorForm.controls['sBranch'].disable();
      this.paytovendorForm.patchValue({ sBranch: "" })
      if (this.ArrInvoice.filter(f => f.cActive != 'N').length > 0) {
        this.ArrInvoice.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          invoice.cbOffice = _this.paytovendorForm.value.cbOffice == 1 ? 1 : _this.paytovendorForm.value.cbOffice;
          invoice.nOfficeType = _this.paytovendorForm.value.cbOffice == 1 ? 1 : _this.paytovendorForm.value.cbOffice;
          invoice.sVendorBranch = "";
        })
      }
    }
  }
  OnSkipApprove1() {
    let _this = this;
    if (_this.paytovendorForm.value["cSkipApprove1"]) {
      _this.paytovendorForm.patchValue({ sApprove1: null });
      _this.paytovendorForm.get('ddApprover1').reset();
      _this.paytovendorForm.get('ddApprover1').disable();
    }
    else {
      let name1 = _this.DataApprover.filter(f => f.nUserID == _this.GetApprover.name1ID)[0];
      let nUserId = _this.DataApprover.filter(f => f.nUserID == _this.GetApprover.name1ID)[0];
      this.paytovendorForm.patchValue({
        ddApprover1: isNullOrUndefined(name1) == true ? "" : name1.name1,
        sApprove1: isNullOrUndefined(nUserId) == true ? null : nUserId.nUserID,
      })
      this.paytovendorForm.get('ddApprover1').enable();
    }
  }
  Export() {
    const link = document.createElement('a');
    link.target = '_blank'
    const httpOptions = {
      params: new HttpParams()
        .set("sReqID", this.sReqID + "")
        .set("nContactID", this.paytovendorForm.get("nContactID").value),

    };
    // link.href = this.System.SiteName + "api/ExportPDF/export/" + this.sReqID + "/" + this.paytovendorForm.get("nContactID").value;
    link.href = this.System.SiteName + "api/ExportPDF/export?" + httpOptions.params
    link.setAttribute('visibility', 'hidden');
    link.click();
  }
  Back() {
    this.router.navigate(['/home'])
  }

  OnUploadExcelFile() {
    let _thisOther = this;
    _thisOther.ArrGL.clear();
    _thisOther.ArrInvoice = [];
    _thisOther.arrExcel = [];
    _thisOther.fileName = "";
    _thisOther.fileDetail = null;
    _thisOther.ExcelData = null;
    if (this.paytovendorForm.get("IsUploadExcelFile").value == false) {
      _thisOther.AddGL();
    }
  }

  //#region "SetForm"
  SetForm() {
    let ua = this.System.GetUserStorage()
    this.paytovendorForm = this.formBuilder.group({
      sRequestID: [null],
      sRequestBy: [ua.nUserID],
      nContactID: [ua.nUserID],
      sName: [ua.sFullName, Validators.required],

      sEmail: [ua.sEmail, Validators.pattern("^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$")],
      sUnit: [ua.sUnitName],
      sTel: [ua.sTel],
      dToday: [this.dToday],
      sCompCode: [ua.sCompCode],
      sCompName: [ua.sCompName],
      sBusinessArea: [null],
      IsUploadExcelFile: [false],

      ntype: ["70"],
      dDueDate: [null, Validators.required],
      sCopyRequest: [null],
      nCopyRequest: [null],
      sOtherRefNoFIDocNo: [null],
      nVendorCode: [null, Validators.required],
      sTAXID: [null, Validators.required],
      sVendorName: [null, Validators.required],
      cbOffice: [1],
      cbReceiveTypeB2C: [1],
      sBranch: [null],
      sAddress: [null, Validators.required],

      sCountryID: "",
      txtCountryID: "",
      sProvCode: "",
      sProvName: "",
      sAmpCode: "",
      sAmpName: "",
      sTumbonCode: "",
      sTumbonName: "",
      sPostCode: "",
      sPhoneNumber: "",
      sFaxNumber: "",
      sVendorEmail: "",
      sAddressOneTime: "",

      sInvoiceNo: ['-'],
      dInvoiceDate: [new Date(), Validators.required],
      sDescription: [null, Validators.required],
      nTotalAmount: [null],
      ddCurrency: ["THB"],
      nVat: [null,],
      ddVatType: ["-1"],
      nVatAmount: [null, Validators.required],
      nTotalAmountInvoice: [null],
      nTotalAmountVat: [null, Validators.required],
      ddlWithholdingTax: " ",
      ddlWithholdingTax2: " ",
      nWHTRate: [null],
      nWHTRate2: [null],
      nWHTOther: [null],
      nWHTOther2: [null],
      nWHTVal: [null],
      _nWHTVal: [null],
      nWHTVal2: [null],
      _nWHTVal2: [null],
      nWHTBase: [null],
      nWHTBase2: [null],
      sComment: [null],
      sCommentSSC: [null],

      ArrGL: new FormArray([
        new FormGroup({
          sGL: new FormControl('', Validators.required),
          sCostCenter: new FormControl(''),
          sIO: new FormControl(''),
          sProfitCenter: new FormControl('', Validators.required),
          sAmountExcludedVAT: new FormControl('', Validators.required),
          sText: new FormControl('', Validators.required),
          IsDelete: new FormControl(false),
          sInvoiceNo: new FormControl('-'),
          nline: new FormControl('')
        })
      ]),

      GtotalAmountOfInvoice: [null],
      GtotalAmountExcluded: [null],
      GtotalWithholdingTax: [null],
      GtotalVAT: [null],

      ddApprover1: [null, Validators.required],
      sApprove1: [null],
      sApprove2: [null],
      ddApprover2: [null, Validators.required],
      cSkipApprove1: [null],
    });
  }
  //#endregion

  CheckPattern(event) {
    const charCode = event.key;
    if (charCode != "Backspace") {
      var regExp = new RegExp('[0-9]', 'g');
      if (regExp.test(charCode)) {
        return true;
      } else {
        return false;
      }
    }
  }
  getReqID() {
    let comcode = this.nComcode;
    let width = comcode.toString().length;
    if (width > 0) {
      comcode = new Array(width == 3 ? 0 : 3).join('0') + comcode;
    }
    let dToday = this.datepipe.transform(this.today, 'yyMMdd')
    let type = this.paytovendorForm.value.ntype;
    let ReqID: string = comcode + dToday + type;
    return ReqID;
  }

  //#region Validate
  isFieldValid(_Field: string) {
    return !this.paytovendorForm.get(_Field).valid && this.paytovendorForm.get(_Field).touched;
  }
  displayFieldCss(_Field: string) {
    return {
      'has-error': this.isFieldValid(_Field),
      'has-feedback': this.isFieldValid(_Field)
    };
  }
  isFieldValidTbGl(_Field: string, _inx) {
    let FromArray = this.paytovendorForm.get('ArrGL') as FormArray;
    return !FromArray.at(_inx).get(_Field).valid && FromArray.at(_inx).get(_Field).touched;
  }
  displayFieldCssTbGl(_Field: string, _inx) {
    return {
      'has-error': this.isFieldValidTbGl(_Field, _inx),
      'has-feedback': this.isFieldValidTbGl(_Field, _inx)
    };
  }
  //#endregion
  async checkDupinBase(Invoice, InvoiceDate) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let chunks = InvoiceDate.split('/');
    let dInvoiceDate = (chunks[1] + '-' + chunks[0] + '-' + chunks[2]);
    let data = JSON.stringify({ Invoice: Invoice, InvoiceDate: dInvoiceDate, sCompCode: this.nComcode })
    return await this.http.post(this.System.SiteName + "api/_Paytovendor/CheckDupinBase", data, { headers, responseType: 'text' }).toPromise().then(s => s);
  }

  async EditcheckDupinBase(Invoice, InvoiceDate, sReqid) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let chunks = InvoiceDate.split('/');
    let dInvoiceDate = (chunks[1] + '-' + chunks[0] + '-' + chunks[2]);
    let data = JSON.stringify({ Invoice: Invoice, InvoiceDate: dInvoiceDate, sReqid: sReqid, sCompCode: this.nComcode })
    return await this.http.post(this.System.SiteName + "api/_Paytovendor/EditCheckDupinBase", data, { headers, responseType: 'text' }).toPromise().then(s => s);
  }
  CalGrand() {
    let _this = this;
    this.Currencys = this.paytovendorForm.get('ddCurrency').value;
    let arrGtotalAmountOfInvoice = _this.ArrInvoice.filter(f => f.IsDelete == false && f.cActive != 'N').map(m => _this.Check2Digit(m.sAmount));
    //Grand Total Amount Excluded VAT
    let GtotalAmountExcluded = arrGtotalAmountOfInvoice.reduce((acc, cur) => (acc + cur), 0).toFixed(2)
    //Grand Total VAT
    let GroupByinvoice = [];
    let arrinvoiceVat = [];
    let arrinvoiceWHT = [];
    _this.ArrInvoice.filter(f => f.IsDelete == false && f.cActive != 'N').forEach(function (value, i) {
      //GroupByinvoice[value.sInvoiceNo] = GroupByinvoice[value.sInvoiceNo] || [];
      let obj = {
        invoice: value.sInvoiceNo,
        InvoiceDate: value.dInvoiceDate
      }
      let ckhave = GroupByinvoice.filter(f => f.invoice == obj.invoice && f.InvoiceDate == obj.InvoiceDate);
      if (ckhave.length == 0) {
        GroupByinvoice.push(obj)
      }
    });
    GroupByinvoice.forEach(function (value, i) {
      //arrinvoiceVat.push(_this.ArrInvoice.filter(f => f.sInvoiceNo == value.invoice && f.dInvoiceDate == value.InvoiceDate && f.IsDelete == false && f.cActive != 'N')[0].nVAT)
      let Get_InvoiceVat = _this.ArrInvoice.filter(f => f.sInvoiceNo == value.invoice && f.dInvoiceDate == value.InvoiceDate && f.IsDelete == false && f.cActive != 'N');
      if (Get_InvoiceVat.length > 0) {
        arrinvoiceVat.push(_this.Check2Digit(Get_InvoiceVat[0].nVAT));
        arrinvoiceWHT.push(_this.Check2Digit(Get_InvoiceVat[0].nWHTVal) + _this.Check2Digit(Get_InvoiceVat[0].nWHTVal2));
      }
    })
    let GtotalVAT = _ParseFloatToZero(arrinvoiceVat.reduce((acc, cur) => (acc + cur), 0));
    let GtotalWHT = _ParseFloatToZero(arrinvoiceWHT.reduce((acc, cur) => (acc + cur), 0));
    ////Grand Total Withholding Tax
    //let GtotalAmountExcluded = arrGtotalAmouGtotalAmountExcluded.reduce((acc, cur) => acc + Number(cur), 0).toFixed(2)
    //Grand Total Amount
    // let arrGtotalWithholdingTax = _this.ArrInvoice.filter(f => f.IsDelete == false && f.cActive != 'N').map(m => _ParseFloatToZero(m.nWHTVal));
    // let arrGtotalWithholdingTax2 = _this.ArrInvoice.filter(f => f.IsDelete == false && f.cActive != 'N').map(m =>_ParseFloatToZero(m.nWHTVal2));
    // let GtotalWithholdingTax = _ParseFloatToZero(arrGtotalWithholdingTax.reduce((acc, cur) => (acc + cur), 0))
    // let GtotalWithholdingTax2 = _ParseFloatToZero(arrGtotalWithholdingTax2.reduce((acc, cur) => (acc + cur), 0))

    let GtotalAmountOfInvoice = _ParseFloatToZero(((_ParseFloatToZero(GtotalVAT) + _ParseFloatToZero(GtotalAmountExcluded)) - _ParseFloatToZero(GtotalWHT)).toFixed(2))
      this.paytovendorForm.patchValue({
      GtotalAmountExcluded: (GtotalAmountExcluded),
      GtotalVAT: (GtotalVAT),
      GtotalWithholdingTax: (GtotalWHT == "NaN" ? 0 : GtotalWHT),
      GtotalAmountOfInvoice: (GtotalAmountOfInvoice),
    })

  }
  numberOnly(event): boolean {
    const charCode = event.key;
    var regExp = new RegExp('[A-Za-z]', 'g');
    if (regExp.test(charCode)) {
      return false;
    } else {
      return true;
    }
  }
  convertTodate(dDate) {
    let chunks = dDate.split('/');
    return new Date(chunks[1] + '-' + chunks[0] + '-' + chunks[2]);
  }

  convertTodate2(dDate) {
    let chunks = dDate.split('/');
    return `${('0' + chunks[1]).slice(-2)}/${('0' + chunks[0]).slice(-2)}/20${chunks[2]}`
  }

  _ConvertToDecimal(sVal) {
    if(!sVal || sVal === 'NaN') sVal = '0';
    let NoComma = (sVal + "").replace(/,/g, "");//ตัด Comma ออก
    let Data = this._decimalPipe.transform(NoComma, "1.2-2");
    return Data;
  }
  //NoResult
  TypeNoResults(event: boolean): void {
    this.TypeNoResult = event;
    if (event) {
      this.VendorCodemaxLength = 11;
    } else {
      this.VendorCodemaxLength = 50;
    }
  }
  async TypeOnBlur(event) {
    var vendorcode = this.paytovendorForm.get('nVendorCode').value;
    var ischeck = this.ArrVendor.filter(f => f.CUSTOMER_CODE == vendorcode || f.Vendor == vendorcode)[0];
    if (this.TypeNoResult == true && this.paytovendorForm.get("ntype").value == "70") {
      this.paytovendorForm.patchValue({ nVendorCode: null });
      this.ClearInvoice();
    } else if (this.TypeNoResult == true && this.paytovendorForm.get("ntype").value != "70") {
      await this.onTypeSelect(null, true);
    }
    if (this.TypeNoResult == false && !isNullOrUndefined(ischeck)) {
      this.onVendorSelect(event);
    } else if (this.TypeNoResult == false && isNullOrUndefined(ischeck)) {
      this.paytovendorForm.patchValue({ nVendorCode: null });
      this.ClearInvoice();
    }
    if (this.IsVendorOneTime == true) {
      if (this.ArrInvoice.filter(f => f.cActive != 'N').length > 0) {
        this.ArrInvoice.filter(f => f.cActive != 'N').forEach(function (invoice, i) {
          if (event.value != null && !_IsNullOrEmpty(event.value)) {
            invoice.sVendorCode = event.value == null ? "" : event.value;
          } else {
            invoice.sVendorCode = "";
          }
        })
      }
    }
  }
  CopyNoResults(event: boolean): void {
    this.CopyNoResult = event;
  }
  CopyOnBlur(item) {
    let sCopyRequest = this.paytovendorForm.get('sCopyRequest').value;
    let ischeck = this.DataRequest.filter(user => user.sRequestCode == sCopyRequest)[0];
    if (this.DataRequest) {
      if (sCopyRequest == "") {
        /*  this.ArrInvoice = [];
          this.ClearInvoice();
          this.Checkinvoice(); */

      } else if (sCopyRequest != "" && this.CopyNoResult == false && !isNullOrUndefined(ischeck)) {
        this.onCopyRequestCodeSelect(item)
      }
      if (this.CopyNoResult == true) {
        this.paytovendorForm.patchValue({
          sCopyRequest: null,
          nCopyRequest: null
        });
        /*   this.ArrInvoice = [];
           this.ClearInvoice();
           this.Checkinvoice();*/
      } else if (this.CopyNoResult == false && isNullOrUndefined(ischeck)) {
        this.paytovendorForm.patchValue({
          sCopyRequest: null,
          nCopyRequest: null
        });
      }
    }
  }
  //Country NoResult ------------------------------------------

  CountryNoResult(event: boolean): void {
    this.isCountryNoResult = event;
  }
  CountryOnBlur() {
    if (this.isCountryNoResult == true) {
      this.paytovendorForm.patchValue({ txtCountryID: null });
    }
  }
  NoResultsAmphor(event: boolean): void {
    this.sAmphorNoResult = event;
  }
  NoResultsTumbon(event: boolean): void {
    this.sTumbonNoResult = event;
  }
  NoResultsSubDistrict(event: boolean): void {
    this.sSubDistrictNoResult = event;
  }

  //-----------------------------------------------------------
  GlNoResults(event: boolean, index): void {

    this.GlNoResult[index] = event;
  }
  GlOnBlur(event, index) {
    if (this.GlNoResult[index] == true) {
      this.ArrGL.at(index).patchValue({ sGL: null })
    }
  }
  CostCenterNoResults(event: boolean, index): void {
    this.CostCenterNoResult[index] = event;
  }
  CostCenterOnBlur(event, index) {
    if (this.CostCenterNoResult[index] == true) {
      this.ArrGL.at(index).patchValue({ sCostCenter: null })
    }
  }
  IONoResults(event: boolean, index): void {
    this.IONoResult[index] = event;
  }
  IOOnBlur(event, index) {
    if (this.IONoResult[index] == true) {
      this.ArrGL.at(index).patchValue({ sIO: null })
    }
  }
  ProfitCenterNoResults(event: boolean, index): void {
    this.ProfitCenterNoResult[index] = event;
  }
  ProfitCenterOnBlur(event, index) {
    if (this.ProfitCenterNoResult[index] == true) {
      this.ArrGL.at(index).patchValue({ sProfitCenter: null })
    }
  }
  Approver2NoResults(event: boolean): void {
    this.Approve2NoResult = event;
  }
  Approver1NoResults(event: boolean): void {
    this.Approve1NoResult = event;
  }
  //
  Checkinvoice() {
    let _this = this;
    let lstData = this.ArrInvoice.filter(f => f.cActive != 'N')[0];
    this.ArrInvoicelength = this.ArrInvoice.filter(f => f.cActive != 'N').length;
    let onetime = ["sVendorName", "sTAXID", "sAddress", "sBranch", "cbOffice", "txtCountryID", "sProvName", "sAmpName", "sTumbonName"];
    // "sCountryID", "sProvCode", "sAmpCode", "sTumbonCode", "sPostCode", "sPhoneNumber", "sFaxNumber", "sVendorEmail", "sAddressOneTime"
    if (this.ArrInvoice.filter(f => f.cActive != 'N').length >= 1) {
      if (lstData.ntype == "71" || _this.paytovendorForm.get("ntype").value == "71") {
        onetime.forEach(function (value) {
          //  _this.paytovendorForm.controls[value].disable();
          _this.paytovendorForm.controls[value].markAsUntouched({ onlySelf: true });
        })
      }
      //  this.paytovendorForm.controls['dDueDate'].disable();
      this.paytovendorForm.controls['ntype'].disable();
      //  this.paytovendorForm.controls['nVendorCode'].disable();
      this.paytovendorForm.controls['ddCurrency'].disable();
      this.paytovendorForm.controls['nVendorCode'].markAsUntouched({ onlySelf: true });
      //if
    } else {
      onetime.forEach(function (value) {
        _this.paytovendorForm.controls[value].enable();
      });
      this.paytovendorForm.controls['dDueDate'].enable();
      //   this.paytovendorForm.controls['ddCurrency'].enable();
      //  this.paytovendorForm.controls['dDueDate'].enable();
      this.paytovendorForm.controls['ddCurrency'].enable();
      this.paytovendorForm.controls['ntype'].enable();
      //this.paytovendorForm.controls['nVendorCode'].enable();

      this.ClearInvoice();
    }
  }
  clearSubinvoice() {
    let _this = this;
    this.isEdit = false;
    let FieldValid: string[] = ["nVatAmount", "sInvoiceNo", "dInvoiceDate", "ddVatType", "nTotalAmountVat"];
    for (let i = 0; i < FieldValid.length; i++) {
      _this.paytovendorForm.get(FieldValid[i]).markAsUntouched();
    }
    this.paytovendorForm.patchValue({
      sInvoiceNo: '-',
      dInvoiceDate: new Date(),
      nTotalAmount: null,
      // ddCurrency: "THB",
      nVat: null,
      ddVatType: "-1",
      nVatAmount: null,
      nTotalAmountInvoice: null,
      nTotalAmountVat: null,
      ddlWithholdingTax: " ",
      ddlWithholdingTax2: " ",
      nWHTRate: null,
      nWHTRate2: null,
      nWHTOther: null,
      nWHTOther2: null,
      nWHTVal: null,
      _nWHTVal: null,
      nWHTVal2: null,
      _nWHTVal2: null,
      nWHTBase: null,
      nWHTBase2: null,
    })
    this.ArrMaster = [];
    this.ArrMaster.push(this.ArrIO);
    this.ArrGL.clear()
    this._paytovendorForm.ArrGL.reset();
    this.ArrGL.push(new FormGroup({
      sGL: new FormControl('', Validators.required),
      sCostCenter: new FormControl(''),
      sIO: new FormControl(''),
      sProfitCenter: new FormControl('', Validators.required),
      sAmountExcludedVAT: new FormControl('', Validators.required),
      sText: new FormControl('', Validators.required),
      IsDelete: new FormControl(false),
      sInvoiceNo: new FormControl('-'),
      nline: new FormControl('')
    }))
    this.checkUseIo();
    this.checkUseGL();
    this.onWithholdingTaxSelect(1, false);
    this.onWithholdingTaxSelect(2, false);
  }
  calVat() {
    let Total: number = _ParseFloatToZero(this.paytovendorForm.value.nTotalAmountVat)
    let Vat: number = this.paytovendorForm.value.nVat == null ? 0 : this.paytovendorForm.value.nVat
    let VatAmount: number = Total * Vat;
    let include = this.formatnumber(2, true, VatAmount + Total);
    this.paytovendorForm.patchValue({
      nTotalAmountInvoice: this._ConvertToDecimal(include),
      nVatAmount: this._ConvertToDecimal(VatAmount.toFixed(2)),
    })
  }
  checkUseIo() {
    let _this = this;
    if (this.isUseIo) {
      _this.IsNotFill_IO = false;
      _this.ArrGL.controls.forEach(function (row) {
        row.get('sIO').enable();

      })
    } else {
      _this.IsNotFill_IO = true;
      _this.ArrGL.controls.forEach(function (row) {
        row.get('sIO').disable();
      })
    }
  }
  checkUseGL() {
    let _this = this;
    if (this.isUseGL) {
      _this.IsNotFill_GL = false;
      _this.ArrGL.controls.forEach(function (row) {
        row.get('sGL').enable();


      })
    } else {
      _this.IsNotFill_GL = true;
      _this.ArrGL.controls.forEach(function (row) {
        row.get('sGL').disable();
      })
    }
  }
  Check2Digit(sValue) {
    let Result: number = 0;
    if (sValue) {
      let sValueNoComma = (sValue + "").replace(/,/g, "")
      let sValueNoComma2 = Math.round(parseFloat(sValueNoComma) * 100) / 100
      Result = Number(sValueNoComma2.toFixed(2));
    }
    return Result;
  }
}
function _IsNullOrEmpty(str) {
  var Result = true;
  if (str && str != "null") {
    Result = false;
  }
  return Result;
}
function _ParseFloatToZero(sVal) {
  let Result: any = 0;
  if (sVal) {
    let NoComma = (sVal + "").replace(/,/g, "");//ตัด Comma ออก
    Result = parseFloat(NoComma);
  }
  return Result;
}
function _ParseFloatToNull(sVal) {
  let Result: any = null;
  if (sVal) {
    let NoComma = (sVal + "").replace(/,/g, "");//ตัด Comma ออก
    Result = parseFloat(NoComma);
  }
  return Result;
}
